// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

/**
 * Autor: SIVOL® - Aldo Frias - Argentina
 * Fecha: 11/03/2026 22:50 (Argentina - UTC-3)
 * Translations for IT
 * @file translations.it.js
 * @description Main application translations for it
 * @version v3.1.0
 */

import { PRESET_LOCALES } from '../presencePresetI18n.js';

export const translationsIt = {
                'login.title': 'Accedi',
                'login.slogan': 'Conversazioni senza confini!',
                'login.username': 'Nome utente',
                "login.password": "Password",
                'login.submit': 'Accedi',
                'login.loading': 'Caricamento...',
                'login.autoRegister.title': 'Registrazione automatica',
                'login.autoRegister.description': 'Se non hai un account, inserisci il tuo nome utente e password. Verrà creato automaticamente.',
                'login.forgotPassword': 'Password dimenticata?',
                'login.passwordRecovery.title': 'Recupera password',
                'login.passwordRecovery.description': 'Inserisci la tua email per ricevere un link di recupero.',
                "login.passwordRecovery.emailLabel": "E-mail",
                'login.passwordRecovery.emailPlaceholder': 'Inserisci la tua email',
                'login.passwordRecovery.emailHelp': 'Un link di recupero sarà inviato alla tua email',
                'login.passwordRecovery.send': 'Invia',
                'login.passwordRecovery.success': 'Un link di recupero è stato inviato alla tua email. Controlla la tua casella di posta.',
                'login.passwordRecovery.successTitle': 'Email inviata',
                'login.passwordRecovery.successMessage': 'Ti abbiamo inviato un\'email con le istruzioni per reimpostare la password.\nControlla la posta in arrivo e la cartella spam. Il link potrebbe impiegare alcuni minuti.',
                'login.passwordRecovery.devExplanation': 'In modalità sviluppo l\'email non viene inviata alla tua casella; viene salvata per l\'anteprima. Usa «Visualizza email» per vedere il contenuto e il link di recupero.',
                'login.passwordRecovery.devSinkNotice': '⚠️ Modalità sviluppo: questa email NON è stata inviata alla tua casella. Usa «Visualizza email» per aprire il messaggio generato e il link.',
                'login.passwordRecovery.invalidEmail': 'Inserisci un indirizzo email valido',
                'login.error.invalidPassword': 'Password non valida',
                'common.language': 'Lingua',
                'common.loading': 'Caricamento…',
                'common.back': 'Indietro',
                'common.backToStart': 'Torna alla home',
                'common.changeUser': 'Cambia utente',
                'common.request_id_label': 'ID richiesta',
                'login.email.invalid': 'Inserisci un indirizzo email valido',
                'captcha.solve': 'Risolvi correttamente il CAPTCHA',
                'captcha.generateError': 'Errore nella generazione del CAPTCHA. Ricarica la pagina.',
                'auth.require_email': 'L\'email è richiesta per completare la registrazione. Inserisci la tua email.',
                'auth.invalid_credentials': 'Nome utente o password non corretti.',
                'auth.account_blocked': 'Account inattivo. Inserisci la tua email per riattivarlo.',
                'auth.device_limit_reached': 'Limite dispositivi raggiunto. Disconnetti su un altro dispositivo o passa a un piano superiore.',
                'auth.login.device_limit.title': 'Limite di sessioni o dispositivi raggiunto',
                'auth.login.device_limit.body': 'Il tuo piano consente un numero limitato di sessioni o dispositivi attivi contemporaneamente. Per accedere, esci da un altro dispositivo o chiudi un\'altra sessione attiva, poi riprova.',
                'auth.password_incorrect': 'La password non è corretta.',
                'auth.login.password_error_title': 'Password errata',
                'auth.login.password_attempts_hint': 'Hai 3 tentativi per inserire correttamente la password. Se li superi, dovrai reimpostare la password.',
                'auth.login.password_attempts_exhausted_title': 'Limite di tentativi raggiunto',
                'auth.login.password_attempts_exhausted_body': 'Hai superato i 3 tentativi consentiti. Per continuare, reimposta la password da «Password dimenticata?».',
                'auth.login.go_to_reset_password': 'Vai al reset della password',
                'auth.login.password_remaining_two': 'Ti restano 2 tentativi.',
                'auth.login.password_remaining_one': 'Ti resta 1 tentativo.',
                'auth.login.password_attempts_locked_inline': 'Hai raggiunto il numero massimo di tentativi. Devi reimpostare la password.',
                'auth.account_inactive_email_mismatch': 'Account inattivo e l\'email non corrisponde.',
                'auth.captcha_failed': 'CAPTCHA errato. Controlla la risposta.',
                'auth.captcha_expired': 'La tua verifica è scaduta. Ne è stata generata una nuova automaticamente.',
                'auth.unauthorized': 'Non hai il permesso di accedere.',
                'auth.generic_error': 'Si è verificato un errore. Riprova.',
                'auth.method_not_allowed': 'Metodo non consentito.',
                'auth.invalid_data': 'Dati non validi.',
                'auth.credentials_required': 'Nome utente e password obbligatori.',
                'auth.csrf_invalid': 'Sessione non valida. Ricarica la pagina e riprova.',
                'auth.username_taken': 'Questo nome utente è già registrato. Accedi o scegline un altro.',
                'auth.username_unavailable': 'Questo nome utente non è disponibile.',
                'auth.nick_no_spaces': 'Nicknames cannot contain spaces.',
                'auth.password_too_short': 'La password deve essere di almeno 6 caratteri.',
                'auth.rate_limit': 'Troppi tentativi. Attendi un momento e riprova.',
                'auth.confirm_success': 'Account confermato con successo. Reindirizzamento al login...',
                'auth.confirm_already_active': 'Il tuo account è già attivo. Puoi accedere.',
                'auth.reset_sent': 'Se l\'email è registrata, riceverai le istruzioni per reimpostare la password.',
                'auth.reset_token_invalid': 'Link non valido o mancante.',
                'auth.reset_token_expired': 'Questo link è scaduto. Richiedine uno nuovo da "Password dimenticata?".',
                'auth.reset_done': 'Password aggiornata. Ora puoi accedere.',
                'auth.reset_fatal': 'Errore nel salvataggio. Riprova più tardi.',
                'auth.password_mismatch': 'Le password non coincidono.',
                'resetPassword.page.title': 'Nuova password',
                'resetPassword.page.description': 'Inserisci la nuova password (almeno 6 caratteri).',
                'resetPassword.newPassword': 'Nuova password',
                'resetPassword.newPasswordPlaceholder': 'Almeno 6 caratteri',
                'resetPassword.submit': 'Reimposta password',
                'resetPassword.success': 'Password aggiornata. Reindirizzamento al login...',
                'resetPassword.backToLogin': 'Torna al login',

                'account.delete.section_title': 'Elimina account',
                'account.delete.description': 'Eliminando l\'account verranno rimossi in modo permanente tutti i dati, messaggi, contatti e impostazioni. Questa azione non può essere annullata.',
                'account.delete.button': 'Elimina il mio account',
                'accountDeletion.title': 'Eliminazione di account e dati',
                'accountDeletion.description': 'Richiedi l\'eliminazione del tuo account ArChat e dei dati associati.',
                'accountDeletion.openRequest': 'Richiedi eliminazione di account e dati',
                'account.delete.confirm_title': 'Elimina account',
                'account.delete.confirm_message': 'Sei sicuro di voler eliminare il tuo account? Verrà inviata un\'email di conferma alla tua casella. L\'eliminazione è permanente e irreversibile.',
                'account.delete.email_sent_title': 'Email inviata',
                'account.delete.email_sent': 'Ti abbiamo inviato un\'email di conferma. Controlla la casella di posta e clicca sul link per confermare l\'eliminazione.',
                'account.delete.error': 'Impossibile elaborare la richiesta. Riprova.',
                'account.delete.confirm_page_title': 'Conferma eliminazione account',
                'account.delete.confirm_page_desc': 'Stai per eliminare definitivamente il tuo account ArChat. Tutti i dati, messaggi, contatti e impostazioni verranno rimossi. Questa azione non può essere annullata.',
                'account.delete.confirm_final_button': 'Sì, elimina definitivamente il mio account',
                'account.delete.cancel_go_back': 'Annulla e torna indietro',
                'account.delete.done_title': 'Account eliminato',
                'account.delete.done_message': 'Il tuo account è stato eliminato con successo. Tutti i dati sono stati rimossi.',
                'account.delete_token_expired': 'Il link di eliminazione è scaduto o non è più valido. Richiedine uno nuovo dal profilo.',
                'account.delete_token_invalid': 'Link di eliminazione non valido o mancante.',
                'account.delete_email_failed': 'Impossibile inviare l\'email di conferma. Riprova più tardi.',
                'account.delete_error': 'Errore durante l\'eliminazione. Riprova più tardi.',

                'auth.register_success_email_sent': 'Account creato con successo. È stata inviata un\'email di conferma. Controlla la casella di posta (e la cartella spam) e clicca sul link per attivare l\'account.',
                'auth.register_success_email_pending': 'Account creato, ma l\'invio dell\'email di conferma è fallito. Il token di attivazione è ancora valido. Contatta l\'amministratore o richiedi una nuova email di conferma.',
                'auth.email_not_verified': 'Devi confermare la tua email per attivare l\'account.',
                'auth.email_not_verified_title': 'Account in attesa di conferma',
                'auth.email_send_failed': 'Impossibile inviare l\'email. Riprova o cambia email.',
                'auth.email_send_failed_title': 'Impossibile inviare l\'email',
                'auth.register.email_failed.title': 'Account creato',
                'auth.register.email_failed.message': 'Il tuo account è stato creato correttamente, ma c\'è stato un problema nell\'invio dell\'email di conferma. Controlla lo spam o richiedi una nuova email.',
                'auth.register.success.title': 'Account creato',
                'auth.register.success.message': 'Account creato con successo. È stata inviata un\'email di conferma. Controlla la casella di posta (e la cartella spam) e clicca sul link per attivare l\'account.',
                'auth.resend_sent': 'Email di conferma rinviata.',
                'auth.resend_email': 'Rinvia email',
                'auth.retry_resend': 'Riprova',
                'auth.change_email': 'Cambia email',
                'auth.ver_email': 'Visualizza email',
                'auth.already_verified': 'L\'account è già verificato.',
                'auth.confirm_email_title': 'Conferma email',
                'auth.confirm_email_text': 'Il link di attivazione sarà inviato a:',
                'auth.confirm_email_edit': 'Modifica',
                'auth.confirm_email_confirm': 'Conferma',
                'auth.confirm_email_typo_hint': 'Intendevi ***@{suggestion}?',
                'brand.slogan': 'Il potere di essere compresi, indipendentemente dalla lingua',
                "brand.appName": "ArChat®",
                "brand.name": "ArChat®",
                "home.title": "ArChat®",
                'home.slogan': 'Il potere di essere compresi, indipendentemente dalla lingua',
                'home.tagline': 'Messaggistica con traduzione automatica',
                'home.login': 'Accedi',
                'home.register': 'Crea account',
                'home.language': 'Lingua',
                'terms.title': 'Termini e Condizioni',
                'terms.accept': 'Accetta e Continua',
                'terms.reject': 'Rifiuta',
                'terms.rejectShort': 'Non accetto',
                'terms.readAndAccept': 'Ho letto e accetto i Termini e Condizioni',
                'terms.cancel': 'Annulla',
                'register.pageTitle': 'Crea account',
                'register.pageSubtitle': 'Inserisci i tuoi dati per creare l\'account.',
                'register.submitLabel': 'Crea account',
                'register.confirm_title': 'Conferma account',
                'register.confirm_message': 'Stai per creare l\'account:',
                'register.confirm': 'Conferma',
                'register.login_link': 'Hai già un account?',
                'register.password_hint': 'Minimo 6 caratteri',
                'register.checking': 'Verifica…',
                'register.username_taken': 'Questo nome utente è già in uso.',
                'register.available': 'Disponibile',
                'register.emailAlreadyExists': 'Questa e-mail è già registrata.',
                'register.continue': 'Continua',
                'login.demo.title': 'Accesso demo',
                'login.demo.credentials': 'Utente: demo / Password: demo',
                'captcha.label': 'Verifica di sicurezza',
                'security.verification_title': 'Verifica di sicurezza',
                'security.captcha_question': 'Domanda di verifica',
                'security.enter_answer': 'Inserisci la risposta',
                'captcha.description': 'Risolvi l\'operazione matematica per verificare che sei umano',
                'captcha.required': 'Devi inserire la risposta del CAPTCHA per continuare.',
                'menu.conversations': 'Conversazioni',
                'menu.contacts': 'Contatti',
                'menu.dashboard': 'Pannello',
                'menu.profile': 'Il mio profilo',
                'menu.settings': 'Impostazioni',
                'menu.help': 'Aiuto',
                'menu.logout': 'Esci',
                'menu.files': 'I miei file',
                'reviews.menu_title': 'Recensioni',
                'reviews.rate_archat': 'Valuta ArChat',
                'reviews.my_review': 'La mia recensione',
                'navbar.contacts': 'Contatti',
                'navbar.profile': 'Il mio profilo',
                'navbar.settings': 'Impostazioni',
                'navbar.logout': 'Esci',
                'navbar.status': 'Stato',
                'navbar.users': 'Utenti',
                'navbar.no_blocked_users': 'Nessun utente bloccato',
                'navbar.blocked_users_title': 'Utenti bloccati',
                'contacts.blocked_users_title': 'Utenti bloccati',
                'contacts.country_label': 'Paese',
                'contacts.not_reported': 'Non indicato',
                'navbar.user_fallback': 'Utente {id}',
                'onboarding.welcome_title': 'Benvenuto in ArChat®',
                'onboarding.welcome_subtitle': 'Comunica con chiunque in qualsiasi lingua.',
                'onboarding.step1': 'Passo 1',
                'onboarding.step1_title': 'Passo 1',
                'onboarding.step1_description': 'Invita il tuo primo contatto',
                'onboarding.step2': 'Passo 2',
                'onboarding.step2_title': 'Passo 2',
                'onboarding.step2_description': 'Invia il tuo primo messaggio',
                'onboarding.invite_contact': 'Invita contatto',
                'onboarding.explore_archat': 'Esplora ArChat®',
                'contacts.invite_contact': 'Invita contatto',
                'contacts.no_contacts': 'Nessun contatto',
                'help.view_initial_guide': 'Visualizza guida iniziale',
                'suggestions.title': 'Suggerimenti',
                'suggestions.form.title': 'Titolo del suggerimento',
                'suggestions.form.message': 'Descrivi la tua idea',
                'suggestions.form.submit': 'Invia suggerimento',
                'suggestions.send': 'Invia suggerimento',
                'suggestions.captcha_placeholder': 'Risultato',
                'suggestions.cooldown': 'Devi attendere {minutes} minuti prima di inviare un altro suggerimento.',
                'suggestions.success_title': 'Suggerimento inviato',
                'suggestions.success_message': 'Il tuo suggerimento è stato inviato correttamente. Numero di tracciamento: {id}',
                'suggestions.success': 'Grazie per il tuo suggerimento. Il nostro team lo esaminerà.',
                'suggestions.success.title': 'Grazie per il tuo suggerimento!',
                'suggestions.success.reference': 'Riferimento',
                'suggestions.success.review': 'Il nostro team esaminerà la tua idea.',
                'suggestions.success.email': 'Ti abbiamo anche inviato un\'email di conferma.',
                'suggestions.success.copy': 'Copia',
                'suggestions.success.copied': 'Riferimento copiato',
                'suggestions.form.required': 'Titolo e messaggio sono obbligatori.',
                'suggestions.error': 'Invio non riuscito. Riprova.',
                'profile.title': 'Il mio profilo',
                'profile.founderBadge': 'Fondatore #{position}/{limit}',
                'profile.founderTooltip': 'Membro Fondatore – Prezzo bloccato a vita finché l\'abbonamento resta attivo',
                'profile.founderMember': 'Membro Fondatore',
                'profile.founderHeaderBadge': '★ Fondatore #{position}/150',
                'profile.camera.access_denied': 'Impossibile accedere alla fotocamera. Controlla i permessi.',
                'profile.edit': 'Modifica',
                'profile.save': 'Salva modifiche',
                'profile.save.success': 'Il tuo profilo è stato aggiornato con successo.',
                'profile.save.success.title': 'Profilo Aggiornato',
                'profile.update.success.title': 'Profilo Aggiornato',
                'profile.update.success.message': 'Le tue modifiche sono state salvate.',
                'profile.save.error': 'Impossibile aggiornare il profilo. Riprova.',
                'profile.save.error.title': 'Errore di Salvataggio',
                'profile.cancel': 'Annulla',
                'profile.nick': 'Nome utente',
                'profile.nick.help': 'Il tuo identificatore univoco nel sistema',
                'profile.nick.readonly': 'Il nome utente non può essere modificato',
                'profile.nick.readonly.help': 'Il nome utente è unico e non può essere modificato',
                'profile.email.readonly': 'L\'email non può essere modificata',
                'profile.email.readonly.help': 'L\'email è unica e non può essere modificata',
                'profile.name': 'Nome',
                'profile.lastname': 'Cognome',
                "profile.alias": "Alias",
                "profile.email": "E-mail",
                'profile.phone': 'Telefono',
                'profile.language': 'Lingua',
                'profile.country': 'Paese',
                'profile.country.select': 'Seleziona paese',
                'profile.biography': 'Biografia',
                'bio.modal.original': 'Originale',
                'bio.modal.translation': 'Traduzione',
                'bio.modal.empty': 'Questo contatto non ha una biografia.',
                'bio.modal.translating': 'Traduzione in corso...',
                'bio.modal.translation_error': 'Impossibile tradurre la biografia.',
                "attachment.unnamed_file": "Archivio",
                'auth.login_error.default_title': 'Errore di accesso',
                'auth.login_error.default_message': 'Impossibile accedere.',
                'profile.photo': 'Foto del profilo',
                'notifications.bell.aria': 'Notifiche',
                'notifications.panel.title': 'Notifiche',
                'notifications.empty': 'Nessuna notifica',
                'notifications.mark_read': 'Segna come letta aprendo',
                'profile.notifications.sound': 'Suono notifiche',
                'profile.notifications.sound_desc': 'Riproduci suono all\'arrivo di messaggi o avvisi importanti',
                'profile.plan.expires': 'Scade il',
                'profile.plan.loading_info': 'Caricamento delle informazioni del piano...',
                'profile.plan.valid_until': 'Valido fino al:',
                'profile.plan.active_since': 'Attivo dal:',
                'profile.plan.active_badge': '✓ Attivo',
                'billing.change_plan': 'Cambia piano',
                'billing.usage.title': 'Uso del piano',
                'billing.usage.users': 'Utenti',
                'billing.usage.messages': 'Messaggi (oggi)',
                'billing.usage.invitations': 'Inviti (oggi)',
                'billing.usage.messages_month': 'Messaggi questo mese',
                'billing.usage.chats': 'Conversazioni',
                'billing.usage.warning': 'Ti stai avvicinando al limite del tuo piano. Passa a PRO per più capacità.',
                'plans.limit.reached': 'Limite raggiunto — Migliora piano',
                'profile.theme.dark': 'Modalità Scura',
                'profile.theme.light': 'Modalità Chiara',
                "profile.theme.argentina": `Tema dell'Argentina`,
                'modal.title': 'Titolo',
                'modal.success.title': 'Successo',
                'modal.error.title': 'Errore',
                'modal.warning.title': 'Avviso',
                'info.title': 'Informazione',
                'appearance.title': 'Aspetto',
                'appearance.theme.light': 'Chiaro',
                'appearance.theme.dark': 'Scuro',
                "theme.title": "Problema",
                'theme.light': 'Chiaro',
                'theme.dark': 'Scuro',
                'profile.photo.section': 'Foto del profilo',
                'profile.personalInfo': 'Informazioni personali',
                'profile.preferences': 'Preferenze',
                'profile.country.help': 'Il fuso orario verrà assegnato automaticamente in base al paese selezionato',
                'profile.lastname.placeholder': 'Il tuo cognome (opzionale)',
                'profile.name.placeholder': 'Il tuo nome (opzionale)',
                'profile.biography.placeholder': 'Raccontaci di te...',
                'profile.plan.title': 'Piano di Abbonamento',
                'profile.plan.current': 'Piano Attuale',
                'profile.plan.free.description': 'Piano gratuito con limitazioni. Aggiorna a PRO per accesso completo.',
                'profile.plan.pro.description': 'Hai accesso completo a tutte le funzionalità.',
                "profile.plan.upgrade.button": "Passa a PRO",
                'profile.plan.upgrade.hint': 'Access all features without limits',
                'profile.photo.change': 'Cambia foto del profilo',
                'message.placeholder': 'Scrivi un messaggio...',
                'message.placeholderWithFile': 'Invia file',
                'message.sent_from_country': 'Inviato da',
                'message.sent_at_local_time': 'Ora locale del mittente',
                'message.timezone_label': 'Fuso orario',
                'message.context_info': 'Questo messaggio conserva il contesto orario del momento dell\'invio.',
                'message.context_pro_hint': 'Questo messaggio include contesto orario e geografico del mittente nei piani Pro.',
                'message.context_pro_badge': 'Contesto Pro',
                'message.audio.transcribe': 'Trascrivi audio',
                'message.audio.transcribing': 'Trascrizione in corso...',
                'message.audio.transcription': 'Trascrizione',
                'message.audio.error': "Impossibile trascrivere l'audio",
                'attachment.title': 'Allega File',
                'attachment.close': 'Chiudi',
                'attachment.gallery': 'Galleria foto/video',
                'attachment.cameraFront': 'Fotocamera frontale',
                'attachment.cameraBack': 'Fotocamera posteriore',
                'attachment.cameraWeb': 'Webcam',
                'attachment.selectFile': 'Seleziona file (PDF, testo, immagini, video)',
                'attachment.remove': 'Rimuovi',
                'attachments.recipientFreeBlocked.title': 'Limite del piano',
                'attachments.recipientFreeBlocked.sender': 'Questo utente ha il piano Free e non può ricevere allegati.',
                'attachments.recipientFreeBlocked.receiver': '{senderName} ha provato a inviarti un allegato, ma il piano {planName} non consente allegati. Ti consigliamo un piano superiore per ricevere file.',
                'attachments.recipientFreeBlocked.upgradeCta': 'Aggiorna piano',
                'attachment.audioNotSupported': 'I messaggi audio non sono compatibili con ArChat®. Si prega di inviare un messaggio scritto.',
                'message.audioDeprecated.title': 'Messaggio vocale non compatibile',
                'message.audioDeprecated.message': 'Questo messaggio vocale non è più compatibile con ArChat®. Si prega di inviare un messaggio scritto.',
                'camera.title': 'Fotocamera',
                'camera.close': 'Chiudi',
                'camera.switch': 'Cambia fotocamera',
                'camera.capture': 'Scatta Foto',
                'camera.loading': 'Avvio fotocamera...',
                'camera.retry': 'Riprova',
                'camera.error.access': 'Impossibile accedere alla fotocamera. Verifica i permessi.',
                'camera.error.permission': 'Permessi fotocamera negati. Si prega di consentire l\'accesso alla fotocamera nelle impostazioni del browser.',
                'camera.error.notFound': 'Nessuna fotocamera trovata.',
                'camera.error.busy': 'La fotocamera è utilizzata da un\'altra applicazione.',
                'camera.error.constraint': 'I vincoli della fotocamera non possono essere soddisfatti.',
                'profile.photo.take': 'Scatta foto',
                'profile.photo.gallery': 'Scegli dalla galleria',
                'profile.photo.uploading': 'Caricamento immagine...',
                'profile.photo.upload.success': 'Foto del profilo aggiornata con successo',
                'profile.photo.upload.success.title': 'Foto Aggiornata',
                'profile.photo.upload.error': 'Errore durante il caricamento della foto del profilo. Riprova.',
                'profile.photo.upload.error.title': 'Errore di Caricamento',
                'user.default': 'Utente',
                'logout.title': 'Conferma',
                'logout.confirm': 'Sei sicuro di voler uscire?',
                'contacts.title': 'Contatti',
                'contacts.search': 'Cerca contatto',
                'contacts.search.placeholder': 'Cerca per nome utente, nome, cognome, paese o lingua...',
                'contacts.sort': 'Ordina',
                'contacts.sortByName': 'Per nome',
                'contacts.sortByStatus': 'Per stato',
                'contacts.sortByRecent': 'Più recenti',
                'contacts.filter': 'Filtra',
                'contacts.filterAll': 'Tutti',
                'contacts.filterAvailable': 'Disponibili',
                'contacts.filterInvited': 'Invitati',
                'contacts.filterBlocked': 'Bloccati',
                'contacts.pending_invitations': 'Inviti in sospeso',
                'contacts.status.invitation_sent': 'Invito inviato',
                'contacts.empty': 'Nessun contatto',
                'contacts.empty.title': 'Non hai ancora contatti',
                'contacts.empty.message': 'Invita o aggiungine uno per iniziare a chattare.',
                'contacts.empty.invite_button': 'Invita un contatto',
                'contacts.empty.private.message': 'Il tuo profilo è privato. Invita contatti per iniziare a chattare.',
                'contacts.empty.private.invite_button': 'Invita un contatto',
                'contacts.search.no_results': 'Nessun contatto trovato',
                'contacts.search.clear': 'Mostra tutti',
                'contacts.controls.search_placeholder': 'Cerca contatto...',
                'contacts.controls.search_label': 'Cerca contatto',
                'contacts.controls.sort_label': 'Ordina per',
                'contacts.controls.sort.name': 'Nome',
                'contacts.controls.sort.status': 'Stato',
                'contacts.controls.sort.recent': 'Recente',
                'contacts.controls.sort.manual': 'Manuale',
                'contacts.controls.sort.manual_drag_hint': 'Trascina per riordinare',
                'contacts.controls.filter_label': 'Stato',
                'contacts.controls.filter.all': 'Tutti',
                'contacts.controls.filter.available': 'Disponibili',
                'contacts.controls.filter.invited': 'Invitati',
                'contacts.controls.filter.blocked': 'Bloccati',
                'contacts.controls.filter.favorites': 'Preferiti',
                'contacts.nick': 'Nome utente',
                'contacts.name': 'Nome',
                'contacts.lastname': 'Cognome',
                'contacts.country': 'Paese',
                'contacts.language': 'Lingua',
                'contacts.status': 'Stato',
                'status.available': 'Disponibile',
                'status.busy': 'Occupato',
                'status.in_call': 'In chiamata',
                'status.away': 'Assente',
                'status.offline': 'Disconnesso',
                'status.custom': 'Messaggio personalizzato',
                'status.set_title': 'Stato di disponibilità',
                'status.set_button': 'Cambia stato',
                'status.placeholder': 'Messaggio opzionale (es. In riunione)',
                'contacts.status.pending_registration': 'Registrazione in attesa',
                'contacts.status.registered': 'Invitato - Registrato',
                'contacts.status.ready_to_chat': 'Pronto per chattare',
                'contacts.status.active_conversation': 'Conversazione attiva',
                'contacts.invitation.pending.title': 'Invito in Attesa',
                'contacts.invitation.pending.message': 'Questo invito è in attesa di registrazione. Il contatto riceverà un\'email per completare la registrazione. Una volta registrato, potrai chattare con lui.',
                'contacts.error.no_registered': 'Il contatto non è ancora registrato. Attendi che completi la registrazione.',
                'contact.edit.title': 'Modifica contatto',
                'contact.edit.alias.label': 'Alias personalizzato',
                'contact.edit.alias.placeholder': 'Es: Giovanni del lavoro',
                'contact.edit.alias.help': 'Questo nome apparirà al posto del nome reale',
                'contact.edit.nota.label': 'Nota personale',
                'contact.edit.nota.placeholder': 'Aggiungi una nota su questo contatto...',
                'contact.edit.nota.help': 'Note private visibili solo a te',
                'contact.edit.error.noUser': 'Errore: Utente non identificato',
                'contact.edit.error.noContactId': 'Errore: Impossibile identificare il contatto',
                'contact.edit.error.save': 'Errore nel salvataggio',
                'contact.limit.title': 'Limite di contatti raggiunto',
                'contact.limit.message': 'Il piano FREE consente fino a 2 contatti per utente. Passa a FOUNDATION o PRO per più capacità quando la fatturazione sarà abilitata.',
                'contact.edit.info.personalized': 'Queste modifiche sono personalizzate solo per te e non influenzano altri utenti.',
                'contact.edit.profileInfo': 'Informazioni del Profilo',
                'export.title': 'Esporta Conversazione',
                'export.description': 'Seleziona il formato in cui desideri esportare questa conversazione:',
                'export.progress': 'Esportazione...',
                "export.format.pdf": "PDF",
                'export.format.pdf.description': 'Documento PDF con tutte le immagini e i file',
                "export.format.html": "HTML",
                'export.format.html.description': 'File HTML che puoi aprire in qualsiasi browser',
                'export.info': 'L\'esportazione includerà tutti i messaggi, le immagini e i file di questa conversazione.',
                'export.pro_required.title': 'Esporta conversazione',
                'export.pro_required.message': 'Questa funzione è disponibile nel piano PRO.',
                'invitation.title': 'Invita Contatto via Email',
                'invitation.modal.title': 'Invia Invito',
                'invitation.modal.description': 'Invita qualcuno a chattare con te su ArChat®. Riceverà un\'email con un link per accettare l\'invito.',
                'invitation.email.label': 'Email dell\'Ospite',
                'invitation.email.placeholder': 'esempio@email.com',
                'invitation.email.required': 'L\'email è obbligatoria',
                'invitation.email.invalid': 'Inserisci un\'email valida',
                'invitation.language.label': 'Lingua Preferita dell\'Ospite',
                'invitation.language.help': 'L\'email sarà inviata in questa lingua',
                'invitation.mode.label': 'Modalità Conversazione',
                'invitation.mode.profesional': 'Professionale',
                'invitation.mode.profesional.description': 'Conversazione formale e professionale',
                'invitation.mode.tecnico': 'Tecnico',
                'invitation.mode.tecnico.description': 'Conversazione tecnica e specializzata',
                'invitation.mode.casual': 'Casuale',
                'invitation.mode.casual.description': 'Conversazione informale e amichevole',
                'invitation.message.label': 'Messaggio Personale (opzionale)',
                'invitation.message.placeholder': 'Scrivi un messaggio personale per l\'ospite...',
                'invitation.send': 'Invia Invito',
                'invitation.sending': 'Invio in corso...',
                'invitation.success': 'Invito inviato con successo',
                'invitation.error': 'Errore nell\'invio dell\'invito',
                'invitation.error.self': 'Non puoi invitare te stesso',
                'invitation.error.duplicate': 'Esiste già un invito in sospeso per questa email',
                'invitation.list.title': 'Inviti Inviati',
                'invitation.list.empty': 'Non hai inviato nessun invito',
                "invitation.list.email": "E-mail",
                'invitation.list.language': 'Lingua',
                'invitation.list.mode': 'Modalità',
                'invitation.list.status': 'Stato',
                'invitation.list.created': 'Inviato',
                'invitation.list.expires': 'Scade',
                'invitation.list.actions': 'Azioni',
                'invitation.status.pending': 'In sospeso',
                'invitation.status.accepted': 'Accettato',
                'invitation.status.expired': 'Scaduto',
                'invitation.status.cancelled': 'Annullato',
                'invitation.copy.link': 'Copia Link',
                'invitation.copy.success': 'Link copiato negli appunti',
                'invitation.cancel': 'Annulla',
                'invitation.cancel.confirm': 'Sei sicuro di voler annullare questo invito?',
                'invitation.cancel.success': 'Invito annullato con successo',
                'invitation.cancel.title': 'Conferma Annullamento',
                'invitation.resend': 'Reinvia email',
                'invitation.resend.title': 'Reinvia Invito',
                'invitation.resend.success': 'Email di invito reinviata con successo',
                'invitation.resend.error': 'Errore durante il reinvio dell\'email di invito',
                'invitation.accept.title': 'Accetta Invito',
                'invitation.accept.description': 'Sei stato invitato a chattare su ArChat®',
                'invitation.accept.inviter': 'Invitato da',
                'invitation.accept.message': 'Messaggio personale',
                'invitation.accept.login': 'Accedi',
                'invitation.accept.register': 'Registrati',
                'invitation.accept.error.invalid': 'Token di invito non valido',
                'invitation.accept.error.expired': 'Questo invito è scaduto',
                'invitation.accept.error.accepted': 'Questo invito è già stato accettato',
                'invitation.accept.error.cancelled': 'Questo invito è stato annullato',
                'invitation.accept.error.email_mismatch': 'L\'email del tuo account non corrisponde all\'email dell\'invito',
                'invitation.accept.success': 'Invito accettato. Reindirizzamento alla chat...',
                'invitations.sent.title': 'Inviti inviati',
                'invitations.sent.empty': 'Nessun invito in sospeso',
                'invitations.pending.title': 'Inviti in sospeso',
                "invitations.columns.email": "E-mail",
                'invitations.columns.language': 'Lingua',
                'invitations.columns.mode': 'Modalità',
                'invitations.columns.status': 'Stato',
                'invitations.columns.sentAt': 'Inviato',
                'invitations.columns.actions': 'Azioni',
                'invitations.status.pending': 'In sospeso',
                'invitations.status.accepted': 'Accettato',
                'invitations.status.cancelled': 'Annullato',
                'invitations.status.expired': 'Scaduto',
                'invitations.actions.cancel': 'Annulla',
                'invitations.actions.copy': 'Copia link',
                'invitations.actions.resend': 'Rinvia email',
                "profile.privacy.title": "Privacy",
                'profile.privacy.public_visibility': 'Rendi il mio profilo pubblicamente visibile',
                'profile.privacy.public_warning': 'Questo consente a qualsiasi utente di ArChat® di trovarti e avviare una conversazione.',
                'profile.privacy.private_info': 'Il tuo profilo è privato. Solo gli utenti che inviti o che ti invitano potranno chattare con te.',
                'profile.privacy.private_default': 'Per impostazione predefinita, il tuo profilo è privato per maggiore sicurezza.',
                'common.close': 'Chiudi',
                'common.sending': 'Invio...',
                'common.cancel': 'Annulla',
                'common.confirm': 'Conferma',
                'common.save': 'Salva',
                'common.saving': 'Salvataggio...',
                'buttons.accept': 'Accetta',
                'buttons.cancel': 'Annulla',
                'buttons.save': 'Salva',
                'buttons.edit': 'Modifica',
                'buttons.retry': 'Riprova',
                'buttons.confirm': 'Conferma',
                'buttons.yes': 'Sì',
                "buttons.no": "NO",
                'buttons.send': 'Invia',
                'buttons.close': 'Chiudi',
                'buttons.continue': 'Continua',
                'buttons.delete': 'Elimina',
                'buttons.logout': 'Esci',
                'buttons.back': 'Indietro',
                'buttons.update': 'Aggiorna',
                'buttons.upload': 'Carica',
                'buttons.select': 'Seleziona',
                'conversation.backToContacts': 'Torna ai contatti',
                'help.title': 'Aiuto ArChat®',
                'help.what.title': 'Cos\'è ArChat®?',
                'help.what.description': 'ArChat® è un sistema di messaggistica scritta con traduzione automatica che ti permette di comunicare con persone che non parlano la tua lingua, mantenendo chiarezza, contesto e privacy dal primo messaggio.',
                'help.how.title': 'Come funziona?',
                'help.how.step1.title': 'Accedi',
                'help.how.step1.description': 'Usa il tuo nick e password per accedere al sistema. Se non hai un account, verrà creato automaticamente.',
                'help.how.step2.title': 'Invita il tuo contatto',
                'help.how.step2.description': 'Invita il tuo contatto via email dal tuo profilo. Definisci la lingua e la modalità di conversazione dall\'inizio.',
                'help.how.step3.title': 'Scrivi nella tua lingua',
                'help.how.step3.description': 'Scrivi il tuo messaggio nella tua lingua preferita. Il sistema tradurrà automaticamente il messaggio scritto.',
                'help.how.step4.title': 'L\'altro riceve tradotto',
                'help.how.step4.description': 'Il destinatario riceve il messaggio automaticamente tradotto nella sua lingua, mantenendo chiarezza e contesto.',
                'help.features.title': 'Caratteristiche principali',
                'help.features.translation': '🌐 Traduzione automatica e istantanea tra lingue',
                'help.features.status': '💬 Stato di presenza (Online, Inattivo, Non disturbare, ecc.)',
                'help.features.statusCustom': '💬 Stati personalizzati con emoji e messaggio personalizzato',
                'help.features.contacts': '👥 Lista completa di contatti con ricerca e filtri',
                'help.features.contactsMobile': '📱 Vista mobile ottimizzata con informazioni complete (cognome, paese, stato)',
                'help.features.contactsFilter': '👁️ Pulsante per mostrare/nascondere contatti non preferiti - riduce la lista solo ai tuoi preferiti',
                'help.features.contactAlias': '✏️ Alias personalizzato e note private per ogni contatto - clicca sul nome del contatto nella conversazione',
                'help.features.themes': '🎨 Due temi disponibili: Argentina (azzurro/bianco/dorato) e Scuro (viola profondo)',
                'help.features.messages': '📨 Messaggistica in tempo reale con indicatori di lettura',
                'help.features.attachments': '📎 Allega file compatibili con comunicazione scritta: immagini, video e documenti PDF',
                'help.features.camera': '📸 Cattura foto con fotocamera frontale, posteriore o webcam',
                'help.features.gallery': '🖼️ Selezione file dalla galleria',
                'help.features.compression': '🗜️ Compressione automatica delle immagini e generazione di miniature',
                'help.features.progress': '📊 Barra di avanzamento durante il caricamento dei file',
                'help.features.delete': '🗑️ Eliminazione dei propri messaggi',
                'help.features.scroll': '⬇️ Scorrimento automatico all\'ultimo messaggio all\'apertura della conversazione',
                'help.features.profile': '👤 Profilo personalizzabile con avatar, biografia e preferenze',
                'help.features.profileEdit': '✏️ Modifica del profilo senza interruzioni (nessun aggiornamento durante la modifica)',
                'help.features.countries': '🌍 Lista completa di 195+ paesi con selezione automatica del fuso orario',
                'help.features.registration': '📧 Registrazione con conferma via email e CAPTCHA di sicurezza',
                'help.features.multilanguage': '🗣️ Supporto per più lingue (Spagnolo, Inglese, Portoghese, Francese, Tedesco, Italiano, Russo, Cinese, Giapponese, Coreano, Arabo, Hindi)',
                'help.features.pwa': '📲 Applicazione PWA installabile su dispositivi mobili e desktop',
                'help.features.sync': '🔄 Sincronizzazione automatica dei messaggi ogni 5 secondi',
                'help.features.deleteSync': '🗑️ Sincronizzazione automatica dei messaggi eliminati tra dispositivi',
                'help.features.notifications': '🔔 Notifiche sonore per nuovi messaggi ricevuti',
                'help.features.retranslation': '🔄 Re-traduzione automatica dei messaggi se il primo tentativo fallisce',
                'help.features.preview': '👁️ Anteprima dei file prima dell\'invio',
                'help.features.security': '🔒 Sistema di sicurezza con CAPTCHA, impronta digitale del browser e limitazione della velocità',
                'help.features.passwordRecovery': '🔑 Recupero password tramite email',
                'help.features.emailConfirmation': '📧 Conferma account tramite email con link di attivazione',
                'help.features.invitations': '📧 Inviti privati via email - Invita contatti esterni con lingua e contesto definiti',
                'help.features.invitationsManagement': '📋 Gestione completa degli inviti - Elenca, reinvia o annulla inviti in sospeso dal menu',
                'help.features.contactStatus': '🏷️ Stato contatto visibile - Vedi lo stato di ogni contatto (in attesa, registrato, pronto a chattare)',
                'help.features.favorites': '⭐ Sistema preferiti - Segna i contatti come preferiti per accesso rapido',
                'help.features.profilePhoto': '📸 Caricamento foto profilo migliorato - Seleziona immagini dalla galleria con anteprima immediata',
                'help.features.translationSender': '👁️ Visualizzazione traduzioni per il mittente - Vedi come il tuo messaggio è stato tradotto nella lingua del destinatario',
                'help.features.unifiedContacts': '🔗 Modello contatti unificato - I contatti derivano da inviti e conversazioni esistenti',
                'help.features.privacy': '🔒 Modalità privata di default - Il tuo profilo è privato e accessibile solo tramite invito diretto',
                'help.features.export': '💾 Esportazione conversazioni - Esporta conversazioni complete in PDF o HTML con immagini e file',
                'help.tips.title': 'Consigli utili',
                'help.tips.language': '✅ Imposta la tua lingua preferita nel tuo profilo per ricevere messaggi tradotti correttamente',
                'help.tips.status': '✅ Aggiorna il tuo stato di presenza affinché gli altri conoscano la tua disponibilità',
                'help.tips.statusCustom': '✅ Crea stati personalizzati con emoji e messaggio per esprimere il tuo stato attuale',
                'help.tips.search': '✅ Segna preferiti (stella) e blocca utenti dal modal "Utenti"',
                'help.tips.contactsFilter': '✅ Usa il pulsante dell\'occhio (👁️) nella barra superiore per mostrare o nascondere contatti che non sono preferiti',
                'help.tips.contactAlias': '✅ Clicca sul nome del contatto nella conversazione per aggiungere un alias personalizzato e note private',
                'help.tips.avatar': '✅ Clicca sull\'avatar di un contatto per vedere la sua immagine in grande',
                'help.tips.messages': '✅ L\'icona ArChat® lampeggia quando hai messaggi non letti',
                'help.tips.attachments': '✅ Allega immagini, video o PDF usando il pulsante graffetta (📎); compatibile con comunicazione scritta',
                'help.tips.camera': '✅ Usa la fotocamera per catturare foto direttamente dall\'app',
                'help.tips.compression': '✅ Le immagini vengono compresse automaticamente per risparmiare spazio',
                'help.tips.delete': '✅ Puoi eliminare i tuoi messaggi cliccando sul pulsante elimina',
                'help.tips.profile': '✅ Modifica il tuo profilo senza preoccupazioni: il sistema non si aggiorna mentre modifichi',
                'help.tips.themes': '✅ Cambia il tema da Impostazioni > Aspetto: Argentina (azzurro) o Scuro (viola profondo)',
                'help.tips.country': '✅ Seleziona il tuo paese nel profilo per configurare automaticamente il fuso orario',
                'help.tips.registration': '✅ Durante la registrazione, verifica la tua email per attivare completamente il tuo account',
                'help.tips.writing': '✅ Scrivi messaggi chiari: ArChat® traduce il significato del testo scritto, mantenendo contesto e chiarezza',
                'help.tips.install': '✅ Installa ArChat® come applicazione PWA sul tuo dispositivo per accesso rapido dal desktop',
                'help.tips.sync': '✅ I messaggi vengono sincronizzati automaticamente ogni 5 secondi - non è necessario aggiornare',
                'help.tips.deleteSync': '✅ Se elimini un messaggio, verrà automaticamente eliminato su tutti i dispositivi del destinatario',
                'help.tips.notifications': '✅ Sentirai un suono quando riceverai un nuovo messaggio da un altro utente',
                'help.tips.retranslation': '✅ Se un messaggio non è stato tradotto correttamente, il sistema proverà a re-traderlo automaticamente',
                'help.tips.preview': '✅ Rivedi l\'anteprima del file prima di inviarlo per assicurarti che sia quello corretto',
                'help.tips.passwordRecovery': '✅ Se hai dimenticato la password, usa il link "Password dimenticata?" nel login',
                'help.tips.emailConfirmation': '✅ Controlla la tua email dopo la registrazione e clicca sul link di conferma',
                'help.tips.languageChange': '✅ Cambia la tua lingua in qualsiasi momento dal selettore di bandiere - si aggiorna istantaneamente',
                'help.tips.inputFixed': '✅ Su PC, la barra di scrittura rimane fissa nella parte inferiore dello schermo per maggiore comfort',
                'help.tips.invitations': '✅ Invita contatti via email dal tuo profilo - Definisci lingua e modalità conversazione dall\'inizio',
                'help.tips.invitationsManagement': '✅ Gestisci i tuoi inviti dal menu "Inviti inviati" - Reinvia email o annulla inviti in sospeso',
                'help.tips.contactStatus': '✅ Osserva lo stato di ogni contatto nella lista - In attesa (arancione), Registrato (verde) o Conversazione attiva (blu)',
                'help.tips.favorites': '✅ Segna i contatti come preferiti con la stella ⭐ - I preferiti appaiono per primi nella tua lista',
                'help.tips.profilePhoto': '✅ Carica la tua foto profilo da "Scegli dalla galleria" - Vedrai un\'anteprima prima di salvare',
                'help.tips.translationSender': '✅ Quando invii un messaggio, espandi il pannello di traduzione per vedere come è stato tradotto nella lingua del destinatario',
                'help.tips.unifiedContacts': '✅ I tuoi contatti vengono mostrati automaticamente quando accettano inviti o hai conversazioni con loro',
                'help.tips.privacy': '✅ Il tuo profilo è privato di default - Attiva la visibilità pubblica in Profilo > Privacy se vuoi che altri ti trovino',
                'help.tips.export': '✅ Esporta conversazioni complete usando il pulsante ⬇️ nell\'intestazione - Scegli PDF o HTML con tutte le immagini',
                'help.support.title': 'Supporto',
                'help.support.description': 'Se hai problemi o domande, contatta l\'amministratore del sistema o consulta la documentazione tecnica disponibile.',
                'help.about.title': 'Informazioni',
                'help.about.developer': 'Sviluppato da:',
                "help.about.location": "MDQ-ARGENTINA",
                'help.about.linkedin': 'Visualizza profilo LinkedIn',
                'presence.title': 'Stato di presenza',
                'presence.currentStatus': 'Stato attuale:',
                'presence.changeStatus': 'Cambia stato',
                "presence.status.online": "In linea",
                'presence.status.online.title': 'Online - Visibile a tutti',
                'presence.status.online.description': 'Online: Visibile a tutti i contatti',
                'presence.status.idle': 'Inattivo',
                'presence.status.idle.title': 'Inattivo - Indica assenza temporanea',
                'presence.status.idle.description': 'Inattivo: Indica che non sei temporaneamente disponibile',
                'presence.status.dnd': 'Non disturbare',
                'presence.status.dnd.title': 'Non disturbare - Indica che preferisci non essere interrotto',
                'presence.status.dnd.description': 'Non disturbare: Segnale visibile che preferisci non essere interrotto',
                'presence.status.busy': 'Occupato',
                'presence.status.busy.title': 'Occupato - Non disponibile',
                'presence.status.busy.description': 'Occupato: Non disponibile',
                "presence.status.offline": "Non in linea",
                'presence.status.offline.title': 'Disconnesso - Apparire offline',
                'presence.status.offline.description': 'Offline: Apparire disconnesso',
                'presence.status.custom': 'Personalizzato',
                'presence.status.custom.title': 'Personalizzato - Stato unico con emoji',
                'presence.status.custom.description': 'Personalizzato: Stato unico con emoji e scadenza opzionale',
                "dashboard.title": "Pannello di controllo",
                'dashboard.planUsage': 'Uso del piano',
                'dashboard.filesSummary': 'I miei file',
                'dashboard.promotions': 'Promozioni',
                'dashboard.sessions': 'Sessioni attive',
                'dashboard.explore': 'Esplora',
                'dashboard.noSessions': 'Nessuna sessione attiva',
                'dashboard.welcomeTitle': 'Benvenuto in ArChat®',
                'dashboard.welcomeSubtitle': 'Comunica in qualsiasi lingua.',
                'dashboard.stepInvite': 'Passo 1: invita il tuo primo contatto',
                'dashboard.stepMessage': 'Passo 2: invia il tuo primo messaggio',
                'dashboard.inviteContact': 'Invita contatto',
                'dashboard.exploreArChat': 'Esplora ArChat',
                'dashboard.promotionsTitle': 'Promozioni',
                'dashboard.promotionsText': 'Panoramica del programma segnalazioni e premi.',
                'dashboard.viewPromotions': 'Vedi promozioni',
                'dashboard.usageTitle': 'Utilizzo del piano',
                'dashboard.sessionsTitle': 'Sessioni attive',
                'dashboard.sessionsEmpty': 'Nessuna sessione attiva',
                'dashboard.filesTitle': 'I miei file',
                'dashboard.viewFiles': 'Vedi i miei file',
                'dashboard.noBlocks': 'Nessun blocco attivo. Attivane almeno uno in Impostazioni.',
                'dashboard.openSettings': 'Apri impostazioni',
                'dashboard.goToContacts': 'Vai ai contatti',
                'dashboard.filesVisible': 'File visibili',
                'dashboard.filesSampleNote': 'Conteggio dalla prima pagina (fino a 500+).',
                'dashboard.loading': 'Caricamento dati...',
                'dashboard.error.title': 'Errore',
                'dashboard.error.load': 'Impossibile caricare i dati di utilizzo',
                'dashboard.error.generic': 'Errore nel caricamento del dashboard',
                'dashboard.error.no_data': 'Impossibile caricare i dati',
                'dashboard.retry': 'Riprova',
                'dashboard.unlimited': 'Illimitato',
                "dashboard.plan.free": "FREE",
                "dashboard.plan.pro": "PRO",
                "dashboard.plan.enterprise": "ENTERPRISE",
                'dashboard.card.contacts': 'Contatti',
                'dashboard.card.chars': 'Caratteri',
                'dashboard.card.chars_month': 'Caratteri questo mese',
                'dashboard.card.storage': 'Archiviazione',
                'dashboard.card.devices': 'Dispositivi attivi',
                'dashboard.upgrade.title': 'Hai bisogno di più risorse?',
                'dashboard.upgrade.message': 'Aggiorna il tuo piano per ottenere più contatti, caratteri, archiviazione e dispositivi attivi.',
                'dashboard.upgrade.button': 'Migliora piano',
                'upgrade.title': 'Migliora piano',
                'upgrade.close': 'Chiudi',
                'upgrade.cancel': 'Annulla',
                'upgrade.activate': 'Attiva piano PRO',
                'upgrade.activating': 'Attivazione...',
                'upgrade.price.note': '',
                'upgrade.comparison.title': 'Confronto piani',
                'upgrade.free.label': 'Piano gratuito',
                'upgrade.free.limits.contacts': '2 contatti massimo',
                'upgrade.free.limits.conversations': '2 conversazioni massimo',
                'upgrade.free.limits.no_export': 'Nessuna esportazione dati',
                'upgrade.free.limits.no_advanced': 'Nessuna funzionalità avanzata',
                'upgrade.pro.label': 'Piano Pro',
                'upgrade.pro.recommended': 'CONSIGLIATO',
                'upgrade.pro.benefits.contacts': 'Contatti illimitati',
                'upgrade.pro.benefits.contacts.desc': 'Aggiungi tutti i contatti di cui hai bisogno senza restrizioni',
                'upgrade.pro.benefits.conversations': 'Conversazioni illimitate',
                'upgrade.pro.benefits.conversations.desc': 'Mantieni tutte le conversazioni attive di cui hai bisogno',
                'upgrade.pro.benefits.export': 'Esportazione conversazioni',
                'upgrade.pro.benefits.export.desc': 'Esporta le tue conversazioni in più formati (PDF, TXT, JSON)',
                'upgrade.pro.benefits.notifications': 'Notifiche avanzate',
                'upgrade.pro.benefits.notifications.desc': 'Notifiche personalizzate e configurazione avanzata',
                'upgrade.pro.benefits.translation': 'Traduzione automatica illimitata',
                'upgrade.pro.benefits.translation.desc': 'Traduci messaggi senza limiti di utilizzo',
                'upgrade.pro.benefits.files': 'Invio file illimitato',
                'upgrade.pro.benefits.files.desc': 'Condividi file di qualsiasi dimensione senza restrizioni',
                'upgrade.pro.benefits.themes': 'Temi personalizzati',
                'upgrade.pro.benefits.themes.desc': 'Accesso a tutti i temi e personalizzazione avanzata',
                'upgrade.pro.benefits.security': 'Sicurezza avanzata',
                'upgrade.pro.benefits.security.desc': 'Protezione aggiuntiva e funzionalità di privacy migliorate',
                'upgrade.pro.benefits.analytics': 'Statistiche e analisi',
                'upgrade.pro.benefits.analytics.desc': 'Accedi a statistiche dettagliate della tua attività',
                'upgrade.pro.benefits.priority': 'Supporto prioritario',
                'upgrade.pro.benefits.priority.desc': 'Attenzione prioritaria e risposta rapida alle tue richieste',
                'upgrade.enterprise.label': 'Piano Enterprise',
                'upgrade.enterprise.benefits.contacts': 'Contatti illimitati',
                'upgrade.enterprise.benefits.support': 'Supporto prioritario 24/7',
                'upgrade.enterprise.benefits.custom': 'Soluzioni personalizzate',
                'upgrade.enterprise.benefits.advanced': 'Funzionalità aziendali avanzate',
                'upgrade.enterprise.benefits.integration': 'Integrazioni personalizzate',
                'upgrade.enterprise.benefits.dedicated': 'Supporto dedicato',
                'upgrade.success.title': 'Piano PRO attivato',
                'upgrade.success.message': 'Il tuo piano è stato aggiornato a PRO. Goditi tutte le funzionalità illimitate.',
                'upgrade.error.title': 'Errore nell\'attivazione di PRO',
                'upgrade.error.message': 'Impossibile aggiornare il piano. Riprova.',
                'upgrade.error.generic': 'Si è verificato un errore imprevisto. Riprova.',
                'upgrade.benefits.contacts': 'Contatti illimitati',
                'upgrade.benefits.contacts.desc': 'Aggiungi tutti i contatti di cui hai bisogno senza restrizioni',
                'upgrade.benefits.conversations': 'Conversazioni illimitate',
                'upgrade.benefits.conversations.desc': 'Mantieni tutte le conversazioni attive di cui hai bisogno',
                'upgrade.benefits.export': 'Esportazione conversazioni',
                'upgrade.benefits.export.desc': 'Esporta le tue conversazioni in più formati (PDF, TXT, JSON)',
                'upgrade.benefits.notifications': 'Notifiche avanzate',
                'upgrade.benefits.notifications.desc': 'Notifiche personalizzate e configurazione avanzata',
                'upgrade.benefits.translation': 'Traduzione automatica illimitata',
                'upgrade.benefits.translation.desc': 'Traduci messaggi senza limiti di utilizzo',
                'upgrade.benefits.files': 'Invio file illimitato',
                'upgrade.benefits.files.desc': 'Condividi file di qualsiasi dimensione senza restrizioni',
                'upgrade.benefits.themes': 'Temi personalizzati',
                'upgrade.benefits.themes.desc': 'Accesso a tutti i temi e personalizzazione avanzata',
                'upgrade.benefits.security': 'Sicurezza avanzata',
                'upgrade.benefits.security.desc': 'Protezione aggiuntiva e funzionalità di privacy migliorate',
                'upgrade.benefits.analytics': 'Statistiche e analisi',
                'upgrade.benefits.analytics.desc': 'Accedi a statistiche dettagliate della tua attività',
                'upgrade.benefits.priority': 'Supporto prioritario',
                'upgrade.benefits.priority.desc': 'Attenzione prioritaria e risposta rapida alle tue richieste',
                'upgrade.limits.contacts': '2 contatti massimo',
                'upgrade.limits.conversations': '2 conversazioni massimo',
                'upgrade.limits.no_export': 'Nessuna esportazione dati',
                'upgrade.limits.no_advanced': 'Nessuna funzionalità avanzata',
                // API Error Messages
                'api.error.image_processing_not_available': 'L\'elaborazione delle immagini non è disponibile sul server',
                'api.error.image_functions_not_available': 'Funzioni di elaborazione immagini non disponibili',
                'api.error.method_not_allowed': 'Metodo non consentito',
                'api.error.user_not_identified': 'Utente non identificato',
                'api.error.upload_file_too_large_php': 'Il file supera la dimensione massima consentita da PHP',
                'api.error.upload_file_too_large_form': 'Il file supera la dimensione massima consentita dal modulo',
                'api.error.upload_file_partial': 'Il file è stato caricato parzialmente',
                'api.error.upload_no_file': 'Nessun file è stato caricato',
                'api.error.upload_no_temp_dir': 'Directory temporanea mancante',
                'api.error.upload_cant_write': 'Errore durante la scrittura del file su disco',
                'api.error.upload_extension_stopped': 'Un\'estensione PHP ha interrotto il caricamento',
                'api.error.upload_generic': 'Errore nel caricamento del file',
                'api.error.file_type_not_allowed': 'Tipo di file non consentito. Sono consentite solo immagini (JPEG, PNG, GIF, WEBP)',
                'api.error.file_too_large': 'Il file è troppo grande (max 10MB)',
                'api.error.storage_limit_exceeded': 'Limite di archiviazione superato. Aggiorna il tuo piano per caricare più file.',
                'api.error.user_not_found': 'Utente non trovato o inattivo',
                'api.error.image_directory_access': 'Errore nell\'accesso alla directory delle immagini',
                'api.error.file_extension_not_allowed': 'Estensione file non consentita',
                'api.error.temp_file_save': 'Errore nel salvataggio del file temporaneo',
                'api.error.image_processing': 'Errore nell\'elaborazione dell\'immagine',
                'api.error.database_update': 'Errore nell\'aggiornamento del database',
                'api.error.internal_server_error': 'Errore interno del server',
                'api.error.internal_server_error_debug': 'Errore interno del server',
                'api.error.user_id_required': 'ID utente richiesto',
                'api.error.profile_not_found': 'Profilo non trovato',
                'api.error.profile_load_failed': 'Errore nel caricamento del profilo',
                'api.error.invalid_data': 'Dati non validi',
                'api.error.validation_errors': 'Errori di validazione',
                'api.error.profile_update_failed': 'Impossibile aggiornare il profilo',
                'api.error.profile_update_error': 'Errore nell\'aggiornamento del profilo',
                // API Success Messages
                'api.success.photo_updated': 'Foto aggiornata',
                'api.success.profile_loaded': 'Profilo caricato con successo',
                'api.success.profile_updated': 'Profilo aggiornato con successo',
                // Error Messages - Device Limits
                'errors.deviceLimit.title': 'Limite dispositivi raggiunto',
                'errors.deviceLimit.solution': 'Per continuare, disconnettiti da altri dispositivi o migliora il tuo piano.',
                // Error Messages - Network
                'errors.network.title': 'Errore di connessione',
                'errors.network.message': 'Impossibile connettersi al server. Verifica la tua connessione Internet.',
                // Error Messages - Server
                'errors.server.invalidResponse.title': 'Errore del server',
                'errors.server.invalidResponse.message': 'Il server ha restituito una risposta non valida. Riprova.',
                // Error Messages - Generic
                'errors.generic.title': 'Errore',
                'errors.generic.message': 'Si è verificato un errore. Riprova.',
                'errors.generic.403.title': 'Errore di accesso',
                'errors.generic.403.message': 'Non hai il permesso di eseguire questa azione.',
                'errors.saas_max_users': 'Limite utenti del piano raggiunto ({current}/{limit}).',
                'errors.tenant_frozen': 'Il tenant è temporaneamente bloccato.',
                'errors.auth_invalid_credentials': 'Nome utente o password non corretti.',
                'errors.unexpected_error': 'Si è verificato un errore imprevisto. Riprova.',
                'errors.accountInactive.title': 'L\'account è inattivo. Inserisci la tua email per riattivarlo.',
                'errors.accountInactive.activate': 'Attiva ora',
                'errors.accountInactive.accept': 'Accetta',
                'errors.accountInactive.success': 'Account riattivato. Puoi accedere ora.',
                'errors.accountInactive.fail': 'Impossibile riattivare l\'account. Riprova.',
                'errors.accountInactive.completeSuccess': 'Account attivato con la tua email. Puoi accedere ora.',
                'errors.accountInactive.completeFail': 'Impossibile completare l\'attivazione. Verifica l\'email e riprova.',
                // Plan Errors - Device Limit
                'plan.errors.deviceLimit.title': 'Limite del piano raggiunto',
                'plan.errors.deviceLimit.message': 'Il tuo piano attuale ha un limite sul numero di dispositivi che possono essere connessi contemporaneamente.',
                'plan.errors.deviceLimit.solution': 'Per continuare, disconnettiti da altri dispositivi o migliora il tuo piano a PRO.',
                // Plan Errors - Contacts Limit
                'plan.errors.contactsLimit.title': 'Limite di contatti raggiunto',
                'plan.errors.contactsLimit.message': 'Il tuo piano attuale ha un limite sul numero di contatti che puoi avere.',
                'plan.errors.contactsLimit.solution': 'Per aggiungere più contatti, migliora il tuo piano a PRO.',
                // Plan Errors - Invitations Limit
                'plan.errors.invitationsLimit.title': 'Limite di inviti raggiunto',
                'plan.errors.invitationsLimit.message': 'Il tuo piano attuale ha un limite sul numero di inviti che puoi inviare al giorno.',
                'plan.errors.invitationsLimit.solution': 'Per inviare più inviti, migliora il tuo piano a PRO.',
                // Plan Errors - Messages Limit
                'plan.errors.messagesLimit.title': 'Limite di messaggi raggiunto',
                'plan.errors.messagesLimit.message': 'Il tuo piano attuale ha un limite sul numero di messaggi che puoi inviare al giorno.',
                'plan.errors.messagesLimit.solution': 'Per inviare più messaggi, migliora il tuo piano a PRO.',
                // Plan Errors - Storage Limit
                'plan.errors.storageLimit.title': 'Limite di archiviazione raggiunto',
                'plan.errors.storageLimit.message': 'Il tuo piano attuale ha un limite sulla quantità di archiviazione disponibile.',
                'plan.errors.storageLimit.solution': 'Per ottenere più archiviazione, migliora il tuo piano a PRO.',
                // Plan Errors - Upgrade Required
                'plan.errors.upgradeRequired.title': 'Aggiornamento del piano richiesto',
                'plan.errors.upgradeRequired.message': 'Questa funzione richiede un piano superiore a quello attuale.',
                'plan.errors.upgradeRequired.solution': 'Migliora il tuo piano a PRO per accedere a questa funzione.',
                "appearance.theme.system": "Sistema",
                "appearance.theme.corporate": "Aziendale",
                "theme.system": "Sistema",
                "theme.corporate": "Aziendale",
                "founder.title": "FONDAZIONE (Fondatore)",
                'founder.subtitle': 'Sostieni il progetto dall\'inizio con un prezzo a vita.',
                'founder.whatIs': 'I primi 150 utenti ottengono il piano FOUNDATION a prezzo ridotto a vita.',
                'founder.howItWorks': 'Il tuo livello Founder dipende dalla tua posizione (1 a 150).',
                'founder.benefitsTitle': 'Vantaggi',
                'founder.benefitPrice': '$15 / mese (tariffa Founder)',
                'founder.benefitFeatures': 'Include tutte le funzioni del piano PRO.',
                'founder.limit': 'Esistono solo 150 posti Founder.',
                'founder.cancelRule': 'Se annulli, perdi lo status Founder mentre sei disiscritto.',
                'founder.rejoinRule': 'Se si libera un posto, puoi riattivare e tornare Founder automaticamente.',
                'founder.tiers.title': 'Livelli Founder',
                "founder.tiers.legendary.name": "Fondatore LEGGENDARIO",
                'founder.tiers.legendary.range': 'Posizione 1–25',
                'founder.tiers.legendary.desc': 'I primi a sostenere il progetto. Massima priorità storica.',
                "founder.tiers.early.name": "PRIMO Fondatore",
                'founder.tiers.early.range': 'Posizione 26–75',
                'founder.tiers.early.desc': 'Supporto anticipato con riconoscimento speciale.',
                "founder.tiers.founder.name": "fondatore",
                'founder.tiers.founder.range': 'Posizione 76–150',
                'founder.tiers.founder.desc': 'Posto Founder tra i 150.',
                'founder.whatIsLink': 'Cos\'è Founder?',
                'founder.viewTiers': 'Vedi livelli Founder',
                'founder.modalClose': 'Chiudi',
                'founder.activeCountLabel': 'Founder attivi',
                'founder.urgency.lastSlots': 'Ultimi posti Founder disponibili',
                "founder.positionLabel": "Fondatore n. {posizione} / {limite}",
                "founder.leaderboard.title": "I migliori fondatori",
                "login.email.placeholder": "Ingresa tu email para confirmar tu cuenta",
                "login.email.help": "Un link di conferma verrà inviato alla tua email",
                "auth.user_not_found": "Utente non trovato.",
                "auth.user_inactive": `Il tuo account è disattivato. Contatta l'amministratore.`,
                "auth.tenant_mismatch": `Il tuo account non appartiene a questo ambiente. Contatta l'amministratore.`,
                "auth.captcha_required": "È necessario completare la verifica di sicurezza (CAPTCHA).",
                "mail.send_failed": `Impossibile inviare l'e-mail di recupero. Controlla le impostazioni SMTP o riprova più tardi.`,
                "auth.resend_activation": `Invia nuovamente l'e-mail di attivazione`,
                "register.creatingAccount": "Creazione del tuo account…",
                "common.edit": "Modificare",
                "common.on": "Attivato",
                "common.off": "Disabilitato",
                "common.refresh": "Aggiornamento",
                "system.processing": "Elaborazione...",
                "captcha.incorrect": "La risposta al captcha non è corretta.",
                "captcha.placeholder": "Scrivi la risposta",
                "captcha.questionFormat": "Quanto fa {a} + {b}?",
                'menu.admin': 'Amministrazione',
                "navbar.open_guide": "Guida",
                "help.how_archat_works": "Come funziona ArChat®",
                "help.registration": "Documentazione",
                "help.private_invitations": "Inviti privati",
                "help.messaging": "Messaggistica",
                "help.security": "Sicurezza",
                "invitation.quick_button": "Invita contatto",
                "onboarding.title": "Benvenuto su ArChat®",
                "onboarding.subtitle": "Comunica con chiunque in qualsiasi lingua.",
                "onboarding.step1.label": "Passaggio 1",
                "onboarding.step1.text": "Invita il tuo primo contatto",
                "onboarding.step2.label": "Passaggio 2",
                "onboarding.step2.text": "Invia il tuo primo messaggio",
                "onboarding.actions.invite": "Invita contatto",
                "onboarding.actions.explore": "Esplora ArChat®",
                'suggestions.sendSuccess': 'Il tuo suggerimento è stato inviato correttamente.',
                'suggestions.sendError': 'Non è stato possibile inviare il suggerimento. Riprova.',
                'suggestions.sent': 'Suggerimento inviato correttamente.',
                'errors.suggestionSend': 'Non è stato possibile inviare il suggerimento. Riprova.',
                'app.install': 'Installa ArChat',
                "menu.open": "Menu",
                "contacts.controls.hide_non_favorites": "Nascondi i contatti non preferiti",
                "contacts.controls.show_all": "Mostra tutti i contatti",
                "common.navigation": "Navigazione",
                "common.favorite": "Preferito",
                "common.block": "Bloccare",
                "common.user": "Utente",
                "message.new": "nuovo messaggio",
                "message.edit": "Modifica messaggio",
                "message.edit.save": "Salva modifica",
                "message.edit.cancel": "Annulla modifica",
                'message.translating': 'Traduzione in corso...',
                'message.translation_failed': 'Traduzione non riuscita',
                'message.not_translated': 'Testo originale',
                'message.retry_send': 'Riprova',
                'message.retrying': 'Nuovo tentativo...',
                "message.delete": "Elimina messaggio",
                'message.deleted_placeholder': 'Messaggio eliminato',
                "message.edited": "Modificato",
                "message.edited_at": "Modificato il",
                'message.delete_for_me.tooltip': 'Elimina per me',
                'message.delete_for_me.aria': 'Elimina questo messaggio solo per me',
                'message.delete_for_me.confirm_title': 'Elimina messaggio',
                'message.delete_for_me.confirm_message': 'Questo messaggio verrà eliminato solo dalla tua vista.',
                'message.delete_for_everyone.tooltip': 'Elimina per tutti',
                'message.delete_for_everyone.aria': 'Elimina questo messaggio per tutti i partecipanti',
                'message.delete_for_everyone.confirm_title': 'Elimina messaggio per tutti',
                'message.delete_for_everyone.confirm_message': 'Questo messaggio verrà eliminato per te e per l\'altro partecipante.',
                'message.delete_for_everyone.window_expired': 'Finestra di eliminazione scaduta',
                "message.translation.show": "Vedi originale e traduzione",
                "message.translation.hide": "Nascondi traduzione",
                "emoji.search": "Cerca emoji",
                "emoji.close": "Chiudi selettore",
                "captcha.refresh": "Rigenera CAPTCHA",
                'presence.unavailable': 'Stati non disponibili',
                'presence.maintenance': 'Server in manutenzione',
                "home.access_nav": `Accesso all'applicazione`,
                "common.requiredFields": "Completa tutti i campi obbligatori.",
                "bio.view": "Vedi la biografia",
                "profile.invitations.title": "Inviti",
                "profile.invitations.validated": "Inviti convalidati",
                "profile.invitations.nextBadge": "Prossimo traguardo",
                "profile.invitations.progress": "Progressi",
                "profile.invitations.achievement": "Risultato",
                "profile.invitations.topInviterAchieved": "È stato raggiunto il numero massimo di invitati",
                "profile.invitations.badges.networkBuilder": "Costruttore di reti",
                "profile.invitations.badges.topInviter": "Numero massimo di invitati",
                "profile.invitations.achievement.networkBuilderMessage": "Hai invitato 20 utenti su ArChat.",
                "profile.invitations.achievement.topInviterMessage": "Hai invitato 50 utenti su ArChat.",
                "profile.manage_plan": "Gestisci il piano",
                "plan.current_plan": "Piano attuale",
                "plan.current": "Actual",
                'plan.footer_prefix': 'Piano:',
                "plan.upgrade_to_pro": "Passa a PRO",
                "plan.upgrade_to_foundation": "Passa a FONDAZIONE",
                "plan.payment_coming": "Il pagamento con Paddle sarà presto disponibile. Puoi modificare i piani da qui.",
                "plan.payment_coming_title": "Presto",
                "plan.foundation_full": "La quota della FONDAZIONE è piena (150 fondatori). Puoi scegliere PRO.",
                "plan.sold_out": "Esausto",
                "plan.founder_spots_remaining": "Sono disponibili solo {count} posti",
                "plan.founders_occupied": "fondatori impegnati",
                "plan.upgrade_not_allowed": "Solo gli utenti con un piano GRATUITO possono richiedere un aggiornamento.",
                "plan.free_contacts": "Hasta 2 contactos",
                "plan.free_no_files": "Sin archivos",
                "plan.free_retention": "Historial 30 días",
                "plan.pro_files": "Archivos hasta 50MB",
                "plan.pro_export": "Exportación",
                "plan.founder_support": "Prioridad soporte",
                "plan.founder_badge": "Badge fundador",
                "billing.usage.contacts": "Contatti",
                "billing.usage.chars_month": "Caratteri al mese",
                "billing.usage.storage": "Deposito usato",
                "billing.usage.devices": "Dispositivi connessi",
                "billing.loading": "Ricarica...",
                'billing.subscription.section_title': 'Abbonamento e fatturazione',
                'billing.subscription.provider_note': 'Fornitore',
                'billing.subscription.paddle_active': 'Paddle (piano attivo nell\'app)',
                'billing.subscription.mp_action_ok': 'Richiesta registrata. Se il checkout non si è aperto, controlla la connessione o riprova.',
                'billing.paddle.manage_subscription_button': 'Gestisci abbonamento',
                'billing.paddle.portal_confirm_title': 'Portale di fatturazione',
                'billing.paddle.portal_confirm': 'Si aprirà il portale sicuro Paddle per aggiornare metodo di pagamento, fatture o annullare l\'abbonamento. Continuare?',
                'billing.paddle.portal_opened_hint': 'Il portale Paddle è stato aperto in una nuova scheda. Aggiorna il profilo se il piano non si è aggiornato.',
                'billing.paddle.portal_error': 'Impossibile aprire il portale Paddle. Riprova più tardi o contatta il supporto.',
                'billing.paddle.no_link_error': 'Nessun collegamento abbonamento Paddle sul tuo account. Se hai appena pagato, attendi il webhook o contatta il supporto.',
                'billing.paddle.api_not_configured': 'Il server non ha la configurazione API Paddle (PADDLE_API_KEY). Un amministratore deve impostarla.',
                "billing.descriptions.contacts": "Contatti totali memorizzati nel tuo account",
                "billing.descriptions.storage": "Spazio di archiviazione utilizzato per file e contenuti multimediali",
                "billing.descriptions.chars_month": "Personaggi tradotti questo mese",
                "billing.descriptions.devices": "Dispositivi connessi attivi",
                'billing.paddle.return_title': 'Pagamento ricevuto',
                'billing.paddle.return_body': 'Se hai completato il checkout, il piano si aggiornerà a breve dopo la conferma di Paddle. Puoi tornare alla home.',
                'billing.paddle.verifying': 'Verifica del piano…',
                'billing.paddle.not_logged_in': 'Accedi per vedere lo stato aggiornato del piano.',
                'billing.paddle.plan_updated': 'Piano aggiornato: {plan}',
                'billing.paddle.plan_current': 'Il tuo piano attuale: {plan}',
                'billing.paddle.plan_current_founder': 'Ora sei Founder — {plan}',
                'billing.paddle.still_free_hint': 'Se vedi ancora FREE dopo qualche secondo, il webhook potrebbe essere in ritardo. Controlla i log del backend o aggiorna la pagina.',
                'billing.paddle.pro_extra_hint': 'Puoi tornare alla home per usare il tuo piano.',
                "profile.photo.select": "Seleziona foto",
                "profile.photo.select.gallery": "Scegli dalla galleria",
                "avatar.errors.too_large": `L'immagine è troppo grande. Dimensione massima: 2 MB.`,
                "avatar.preview.title": `Anteprima dell'avatar`,
                "profile.avatar.error_title": `Impossibile aggiornare l'avatar`,
                "profile.avatar.error.title": `Impossibile aggiornare l'avatar`,
                "profile.avatar.error.size": `L'immagine supera la dimensione consentita. Il massimo è 2 MB.`,
                "profile.avatar.tooLarge.title": "Immagine troppo grande",
                "profile.avatar.tooLarge.message": "La foto supera le dimensioni consentite. Il massimo è 2 MB.",
                "profile.avatar.uploadError.title": `Impossibile aggiornare l'avatar`,
                "profile.avatar.uploadError.message": `Si è verificato un problema durante il caricamento dell'immagine. Riprova.`,
                "profile.saveSuccess.title": "Profilo aggiornato",
                "profile.saveSuccess.message": "Le tue modifiche sono state salvate con successo.",
                "profile.avatar.file_too_large": `L'immagine supera la dimensione massima consentita (2 MB).`,
                "profile.avatar.file_too_large_hint": `Scegli un'immagine più chiara o riduci le sue dimensioni e riprova.`,
                "profile.photo.take.front": "fotocamera frontale",
                "profile.photo.take.back": "fotocamera posteriore",
                "profile.photo.take.webcam": "webcam",
                "profile.photo.camera.front": "fotocamera frontale",
                "profile.photo.camera.back": "fotocamera posteriore",
                "profile.photo.camera.web": "webcam",
                "profile.photo.close": "Vicino",
                "profile.photo.capture": "Catturare",
                "block.toggle_error": "Impossibile bloccare o sbloccare.",
                "contact.favorite.add": "Aggiungi ai preferiti",
                "contact.favorite.remove": "Rimuovi dai preferiti",
                "contact.block.block": "Bloccare",
                'contact.block.unblock': 'Sblocca',
                "conversation.notFound": "Conversazione non trovata",
                "help.howWorks.title": "👥 Come funziona ArChat® (flusso reale)",
                "help.howWorks.step1.title": "1️⃣ Registrazione",
                "help.howWorks.step1.point1": "Accedi con il tuo nickname e password.",
                "help.howWorks.step1.point2": "Se non hai un account, verrà creato automaticamente.",
                "help.howWorks.step1.point3": "Accetti i Termini e Condizioni nella tua lingua.",
                "help.howWorks.step1.point4": "Confermi il tuo account via e-mail.",
                "help.howWorks.step2.title": "2️⃣ Inviti privati",
                "help.howWorks.step2.point1": "Invita i contatti via email dal tuo profilo.",
                "help.howWorks.step2.point2": "Definire la lingua e la modalità di conversazione prima di iniziare.",
                "help.howWorks.step2.point3": "Il contatto riceve un invito privato.",
                "help.howWorks.step2.point4": "Puoi vedere se è: In sospeso, Registrato, Pronto per chattare",
                "help.howWorks.step2.point5": "I contatti non si cercano, si invitano.",
                "help.howWorks.step2.point6": "I contatti non si cercano, si invitano.",
                "help.howWorks.step3.title": "3️⃣ Contatti e conversazioni",
                "help.howWorks.step3.point1": "I tuoi contatti vengono visualizzati automaticamente quando:",
                "help.howWorks.step3.point2": "accettare un invito",
                "help.howWorks.step3.point3": `oppure c'è una conversazione`,
                "help.howWorks.step3.point4": "Potere:",
                "help.howWorks.step3.point5": "contrassegnateli come preferiti ⭐",
                "help.howWorks.step3.point6": "assegnare loro alias personalizzati",
                "help.howWorks.step3.point7": "aggiungi note private",
                "help.howWorks.step3.point8": "bloccarli o gestirli",
                "help.howWorks.step3.point9": `Non esiste un'agenda pubblica o utenti visibili senza consenso.`,
                "help.howWorks.step4.title": "4️⃣ Messaggi con traduzione",
                "help.howWorks.step4.point1": "Scrivi sempre nella tua lingua.",
                "help.howWorks.step4.point2": "Il sistema traduce automaticamente il messaggio.",
                "help.howWorks.step4.point3": "Il destinatario lo riceve nella sua lingua.",
                "help.howWorks.step4.point4": "Puoi vedere la traduzione applicata.",
                "help.howWorks.step4.point5": "Se una traduzione fallisce, viene ritentata automaticamente.",
                "help.howWorks.step4.point6": "ArChat® dà priorità alla chiarezza e al significato, non solo alla velocità.",
                "help.privacy.title": "🔒 Privacy e controllo",
                "help.privacy.point1": "Il tuo profilo è privato per impostazione predefinita.",
                "help.privacy.point2": "Solo le persone che inviti possono vederti o scriverti.",
                "help.privacy.point3": "La visibilità pubblica è facoltativa e disabilitata per impostazione predefinita.",
                "help.privacy.point4": "Sicurezza attiva con:",
                "help.privacy.point5": "CAPTCHA",
                "help.privacy.point6": "limitazione della velocità",
                "help.privacy.point7": "impronta digitale",
                "help.privacy.point8": "verifica e-mail",
                "help.privacy.point9": "Le tue conversazioni non sono pubbliche né indicizzate.",
                "help.files.title": "📎 File ed esportazione",
                "help.files.point1": "Allega immagini, video e documenti PDF.",
                "help.files.point2": "Cattura foto con la fotocamera anteriore, la fotocamera posteriore o la webcam.",
                "help.files.point3": "Le immagini vengono compresse automaticamente.",
                "help.files.point4": `Anteprima prima dell'invio.`,
                "help.files.point5": "Barra di avanzamento durante il caricamento.",
                "help.files.point6": "Esporta intere conversazioni in:",
                "help.files.point7": "PDF",
                "help.files.point8": "HTML",
                "help.files.point9": "Include messaggi, immagini e file.",
                "help.files.point10": "I tuoi dati sono tuoi.",
                "help.experience.title": "🎨 Esperienza utente",
                "help.experience.point1": "Stati di presenza e stati personalizzati con emoji.",
                "help.experience.point2": "Emoji OpenMoji integrati.",
                "help.experience.point3": "Leggere e scrivere indicatori.",
                "help.experience.point4": "Visualizzazione mobile ottimizzata uguale a desktop.",
                "help.experience.point5": "Applicazione PWA installabile.",
                "help.experience.point6": "Due temi: Argentina (azzurro/bianco/oro) e Oscuro (viola intenso).",
                "help.experience.point7": "Modifica del profilo senza bevande analcoliche.",
                "help.experience.point8": "Selettore del paese con fuso orario automatico.",
                "help.experience.point9": "Accesso rapido con preferiti, ricerca e filtri.",
                "help.languages.title": "🌍 Lingue",
                "help.languages.point1": "Supporto per {count} lingue.",
                "help.languages.point2": "Selettore visivo con bandiere.",
                "help.languages.point3": "Interfaccia, T&C ed e-mail adattati alla lingua scelta.",
                "help.languages.point4": "Traduzione automatica bidirezionale tra gli utenti.",
                "help.tipsNew.title": "💡 Consigli per sfruttare ArChat®",
                "help.tipsNew.point1": "Invita solo le persone con cui vuoi veramente comunicare.",
                "help.tipsNew.point2": "Utilizza alias e note private per organizzare i contatti.",
                "help.tipsNew.point3": "Contrassegna i preferiti per un accesso rapido.",
                "help.tipsNew.point4": "Controlla la traduzione prima di inviare messaggi importanti.",
                "help.tipsNew.point5": "Esporta conversazioni rilevanti per backup o lavoro.",
                "help.tipsNew.point6": "Usa ArChat® quando la chiarezza scritta è fondamentale.",
                "help.whySubscribe.title": "🚀 Perché iscriversi ad ArChat®",
                "help.whySubscribe.point1": "ArChat® non è progettato per chattare con chiunque,",
                "help.whySubscribe.point2": "ma per comunicare meglio con chi conta.",
                "help.whySubscribe.point3": "Se hai bisogno:",
                "help.whySubscribe.point4": "chiarezza tra le lingue",
                "help.whySubscribe.point5": "vera intimità",
                "help.whySubscribe.point6": "controllo dei contatti",
                "help.whySubscribe.point7": "esportazione della conversazione",
                "help.whySubscribe.point8": `un'esperienza professionale e senza rumore`,
                "help.whySubscribe.point9": "ArChat® è progettato per questo.",
                "help.message_time_context.title": "Contesto temporale dei messaggi",
                "help.message_time_context.description": `Ogni messaggio può salvare l'ora locale, il fuso orario e il paese del mittente al momento dell'invio. In questo modo puoi vedere dove e a che ora ha inviato l'altro utente.`,
                "help.message_time_context.point1": `Nel piano GRATUITO viene mostrata solo l'ora del tuo fuso orario (ricevitore).`,
                "help.message_time_context.point2": `Nell'abbonamento PRO vengono visualizzati anche l'ora locale, il paese e il fuso orario dell'emittente.`,
                "help.message_time_context.point3": "Il contesto viene salvato storicamente in ogni messaggio.",
                "help.message_time_context.point4": "Funzionalità di controllo avanzate sono disponibili sui piani superiori.",
                'presence.custom.title': 'Stato personalizzato',
                'presence.custom.status': 'Stato personalizzato',
                'presence.custom.placeholder': 'Es.: Prendo un caffe ☕',
                'presence.custom.emoji': 'Emoji (opzionale)',
                'presence.custom.emojiHelp': 'Seleziona un emoji o scrivine uno',
                'presence.custom.temporary': 'Stato temporaneo (scade automaticamente)',
                'presence.custom.expiration': 'Data di scadenza',
                'presence.custom.expirationHelp': 'Lo stato tornera "Online" alla scadenza',
                'presence.custom.suggestions': 'Suggerimenti',
                'presence.custom.preview': 'Anteprima',
                'presence.custom.save': 'Salva stato',
                'presence.custom.required': 'Lo stato personalizzato e obbligatorio',
                'presence.custom.maxLength': 'Massimo 64 caratteri',
                'presence.custom.expirationRequired': 'Devi selezionare una data di scadenza',
                'presence.custom.expirationFuture': 'La data di scadenza deve essere futura',
                'presence.custom.selectEmoji': 'Seleziona emoji',
                "invitation.success.title": "Invito inviato",
                "invitation.success.message": `Invito inviato con successo.\\n\\nIl contatto riceverà un'e-mail con un collegamento per accettare l'invito. Una volta accettato, puoi iniziare a chattare con lui.`,
                "invitation.top.title": "I migliori costruttori di reti",
                "invitation.top.invitesSuffix": "inviti",
                "invitation.ranking.position": "Posizione",
                "invitation.ranking.user": "Utente",
                "invitation.ranking.validatedInvites": "Inviti convalidati",
                "invitation.ranking.empty": "Non ci sono inviti convalidati da visualizzare.",
                "invitation.ranking.loading": "Caricamento classifica...",
                "invitation.ranking.loadError": "Impossibile caricare la classifica.",
                "invitations.waitBeforeResend": `Non puoi ancora inviare nuovamente l'invito. È necessario attendere 10 minuti tra ogni invio per evitare di inviare spam all'utente ospite.`,
                "invitations.captchaQuestion": "Quanto fa %1 + %2?",
                "invitations.resendSuccess": `L'invito è stato inoltrato con successo.`,
                "invitations.dailyLimit": "Hai raggiunto il numero massimo consentito di nuovi invii oggi.",
                "invitations.invalidEmail": "Il server di posta ha segnalato che questo indirizzo non è valido.",
                "achievement.unlocked": "Obiettivo sbloccato",
                "achievement.continue": "Continuare",
                'dashboard.not_available': 'Non disponibile',
                "plan.errors.chatsLimit.title": "Limite di conversazioni raggiunto",
                "plan.errors.chatsLimit.message": "Il tuo piano attuale prevede un limite al numero di conversazioni che puoi avere.",
                "plan.errors.chatsLimit.solution": "Per creare più conversazioni, aggiorna il tuo piano a PRO.",
                "errors.generic": "Si è verificato un errore imprevisto. Riprova.",
                "errors.modal.title": "Errore",
                "errors.modal.copyDetails": "Copia dettaglio",
                "errors.modal.close": "Vicino",
                "errors.modal.reportSupport": "Segnala al supporto",
                "errors.avatarTooLarge": `L'immagine supera la dimensione consentita di 2 MB.`,
                "errors.avatarTooLarge.title": "Immagine troppo grande",
                "errors.avatarTooLarge.message": `L'immagine supera la dimensione consentita di 2 MB.`,
                "errors.invalidImageType": `Il file selezionato non è un'immagine valida.`,
                "errors.invalidImageType.title": "File non valido",
                "errors.invalidImageType.message": `Il file selezionato non è un'immagine valida.`,
                "errors.uploadFailed": `Impossibile caricare l'immagine. Riprova.`,
                "errors.uploadFailed.title": "Errore durante il caricamento",
                "errors.uploadFailed.message": `Impossibile caricare l'immagine. Riprova.`,
                "errors.conversationCreate": "Errore durante la creazione della conversazione. Per favore riprova.",
                "errors.conversationInvalidId": "ID conversazione non valido.",
                "errors.conversationOpen": `Errore durante l'apertura della conversazione. Per favore riprova.`,
                "errors.favoriteUpdate": "Impossibile aggiornare il preferito",
                "errors.blockUpdate": "Impossibile aggiornare il blocco",
                "errors.messageEdit": "Errore durante la modifica del messaggio.",
                "errors.foundation_sold_out": "I posti per i Fondatori sono esauriti.",
                "errors.userInactive.title": "Conto disattivato",
                "errors.tenantMismatch.title": `Errore dell'inquilino`,
                'auth.tagline': 'Il potere di essere compresi, indipendentemente dalla lingua',
                'auth.sign_in': 'Accedi',
                'auth.create_account': 'Crea account',
                'ui.search_contact': 'Cerca contatto...',
                'ui.language': 'Lingua',
                'profile.my_profile': 'Il mio profilo',
                'profile.status': 'Stato',
                'profile.invite_email': 'Invita Contatto via Email',
                'profile.sent_invitations': 'Inviti Inviati',
                'profile.users': 'Utenti',
                'profile.settings': 'Impostazioni',
                'profile.appearance': 'Aspetto',
                'profile.logout': 'Esci',
                'contacts.mode': 'Modalità',
                'contacts.sent': 'Inviato',
                'contacts.actions': 'Azioni',
                'contacts.pending': 'In sospeso',
                'contacts.available': 'Disponibile',
                'contacts.invited_registered': 'Invitato - Registrato',
                "table.email": "E-mail",
                'table.language': 'Lingua',
                'table.mode': 'Modalità',
                'table.status': 'Stato',
                'table.sent': 'Inviato',
                'table.actions': 'Azioni',
  'promotions.invite.message': 'Ti invito ad ArChat: parla in qualsiasi lingua. Entrambi otteniamo dei benefici.',
  'promotions.progress.pending': 'Hai inviti in sospeso per sbloccare premi.',
  'promotions.progress.in_progress': 'I tuoi inviti sono in corso: i premi si attivano dopo una vera conversazione.',
  'promotions.progress.remaining': 'Hai bisogno di {count} conversazioni in più per ricevere il tuo premio.',
  'promotions.progress.sent_count': 'Inviato',
  'promotions.progress.pending_count': 'In attesa di',
  'promotions.progress.in_progress_count': 'In corso',
  'promotions.progress.completed_count': 'Completato',
  'promotions.banner.empty': 'Inizia ora: invita contatti e sblocca vantaggi.',
  'promotions.banner.pending': 'Hai inviti in sospeso: completa una conversazione reale e guadagna premi.',
  'promotions.banner.reward': 'Hai già sbloccato i premi! Continua a invitare per aumentare i tuoi guadagni.',
  'promotions.cta.copy': 'Copia messaggio e collegamento',
  'promotions.cta.copied': 'Messaggio copiato',
  'promotions.cta.copy_error': 'Impossibile copiare il messaggio',

  'promotions.title': 'Promozioni e premi',
  'promotions.subtitle': 'Invita contatti e sblocca vantaggi attraverso l\\\'utilizzo reale.',
  'promotions.how_it_works': 'Come funziona',
  'promotions.step1': 'Invita un contatto dal tuo profilo.',
  'promotions.step2': 'Quando accettano e chattano con un\\\'interazione reale, questa viene convalidata automaticamente.',
  'promotions.step3': 'Il premio viene accreditato e i tuoi progressi vengono aggiornati.',
  'promotions.rewards.title': 'Premi',
  'promotions.reward.invite': 'Premio per ogni referral convalidato.',
  'promotions.reward.milestone': 'Bonus per traguardi di crescita.',
  'promotions.reward.ranking': 'Visibilità nella classifica dei migliori costruttori di reti.',
  'promotions.progress.title': 'I tuoi progressi',
  'promotions.progress.sent': 'Inviato',
  'promotions.cta.invite': 'Invita contatto',
  'promotions.banner': 'Attiva le promozioni: invita e guadagna premi per un utilizzo reale.',
  'promotions.modal.title': 'Programma di promozioni',
  'promotions.modal.body': 'Guadagna +10.000 caratteri per invito convalidato.\\\\nInvita oggi e sblocca premi.',
  'promotions.modal.cta': 'Visualizza le promozioni',
                "app.install_ios_hint": "Per installare: Condividi > Aggiungi alla schermata iniziale",
                'menu.promotions': 'Promozioni',
                "suggestions.new": "Nuovo suggerimento",
                "suggestions.empty": "Non hai ancora inviato suggerimenti.",
                "suggestions.admin_note": "Nota della squadra",
                "suggestions.status.pending": "Orecchino",
                "suggestions.status.reviewed": "Revisionato",
                "suggestions.status.planned": "Pianificato",
                "suggestions.status.implemented": "Implementato",
                "suggestions.status.rejected": "Respinto",
                "referral.promo": "Invita e vinci 10.000 personaggi",
                "referral.stats.sent": "Inviato",
                "referral.stats.accepted": "Accettato",
                "referral.stats.rewards": "Premi",
                "referral.reward.pending": "Orecchino",
                "referral.reward.granted": "Riempito",
                "referral.reward.invalid": "Non valido",
                "referral.reward.in_progress": "In uso",
                "referral.limit.reached": "Limite del premio raggiunto",
                "referral.waiting.usage": "+10.000 caratteri ciascuno quando tu e il tuo ospite inviate almeno un vero messaggio di testo nella stessa chat (convalidato dal server).",
                "common.avatar": "Avatar",
                "plan.free_characters_month": "30,000 characters / month",
                "plan.pro_characters_month": "300,000 characters / month",
                "messages.empty": "Non ci sono ancora messaggi",
                "messages.loading": "Caricamento messaggi...",
                "messages.connecting_server": "Connessione al server dei messaggi...",
                "messages.pending_send_count": "{count} messaggio/i in attesa di consegna",
                "presence.custom.suggestion.coffee": "Avere degli amici ☕",
                "presence.custom.suggestion.soccer": "In campo ⚽",
                "presence.custom.suggestion.working": "Lavorare come un matto 💪",
                "presence.custom.suggestion.lunch": "Pranzando 🍽️",
                "presence.custom.suggestion.family": "Pranzo in famiglia 👨‍👩‍👧‍👦",
                "presence.custom.suggestion.studying": "Studiare 📚",
                "presence.custom.suggestion.travel": "In viaggio ✈️",
                "presence.custom.suggestion.meeting": "In incontro 💼",
                "presence.custom.suggestion.resting": "Riposo 😴",
                "presence.custom.suggestion.gaming": "Giocare ai videogiochi 🎮",
                "presence.custom.suggestion.reading": "Leggendo 📖",
                "presence.custom.suggestion.offlineSoon": "Torno subito ⏳",
                "invitation.safe.phase_notice": "Fase sicura attiva: benefici in attesa di attivazione commerciale (nessun impatto reale sui limiti).",
                "invitation.safe.generate_code": "Genera collegamento/codice",
                "invitation.safe.refresh_top3": "Aggiorna i primi 3",
                "invitation.safe.top_loading": "Caricamento dei principali invitanti...",
                "invitation.safe.top_empty": "Non ci sono ancora invitati in primo piano.",
                "invitation.safe.hide_full_ranking": "Nascondi la classifica completa",
                "invitation.safe.view_full_ranking": "Vedi la classifica completa",
                "invitation.safe.hide_metrics_dashboard": "Nascondi dashboard delle metriche",
                "invitation.safe.view_metrics_dashboard": "Visualizza il dashboard delle metriche",
                "invitation.safe.prepared_link": "Collegamento preparato",
                "invitation.safe.email_placeholder": "email@dominio.com",
                "invitation.safe.register_pending": "Registrati in attesa di invito",
                "invitation.safe.status_summary": "Riepilogo dello stato",
                "invitation.safe.summary.pending": "Orecchini",
                "invitation.safe.summary.registered": "Registrato",
                "invitation.safe.summary.active": "Attivo",
                "invitation.safe.summary.validated": "Convalidato",
                "invitation.safe.summary.rejected": "Respinto",
                "invitation.safe.sent_invitations": "Inviti emessi",
                "invitation.safe.table.id": "ID",
                "invitation.safe.table.invited_email": "E-mail ospite",
                "invitation.safe.table.code": "Codice",
                "invitation.safe.table.status": "Stato",
                "invitation.safe.table.created": "Creato",
                "invitation.safe.empty_sent": "Nessun invito ancora emesso.",
                "invitation.safe.simulated_rewards": "Premi simulati guadagnati",
                "invitation.safe.empty_rewards": "Nessun premio simulato per ora.",
                "invitation.safe.error.load_status": `Impossibile caricare lo stato dell'invito.`,
                "invitation.safe.error.generate_code": "Impossibile generare il codice.",
                "invitation.safe.error.invalid_email": `Inserisci un'e-mail valida per registrare l'invito.`,
                "invitation.safe.error.register_pending": `Impossibile registrare l'invito in sospeso.`,
                "invitation.safe.success.code_generated": "Codice generato con successo.",
                "invitation.safe.success.pending_registered": "Invito in sospeso registrato in modalità provvisoria.",
                "invitation.status.deleted": "Eliminato",
                "invitation.deleted.tooltip": "Questo invito è stato rimosso",
                "invitation.status.rejected": "Respinto",
                "invitation.status.bounced": "Rimbalzato",
                "invitation.status.unknown": "Stato sconosciuto",
                "dashboard.admin.title": "Metriche di crescita",
                "dashboard.admin.newUsersToday": "Nuovi utenti oggi",
                "dashboard.admin.messagesSentToday": "Messaggi inviati oggi",
                "dashboard.admin.translationsUsed": "Traduzioni utilizzate",
                "dashboard.admin.invitesCreated": "Inviti creati",
                "dashboard.admin.invitesValidated": "Inviti convalidati",
                "dashboard.admin.inviteConversion": `Conversione dell'invito`,
                "dashboard.admin.kFactor": "Fattore K",
                "dashboard.admin.newUsers": "Nuovi utenti",
                "dashboard.admin.messagesSent": "Messaggi inviati",
                "dashboard.admin.noData": "Nessun dato",
                "dashboard.admin.kFactor.viral": "Virale",
                "dashboard.admin.kFactor.stable": "Stabile",
                "dashboard.admin.kFactor.low": "Basso",
                "dashboard.admin.emailMetrics": "Metriche di posta elettronica",
                "dashboard.admin.email.sent": "Inviato",
                "dashboard.admin.email.delivered": "Consegnato",
                "dashboard.admin.email.opened": "aprire",
                "dashboard.admin.email.clicked": "Clic",
                "dashboard.admin.email.bounced": "Rimbalzato",
                "dashboard.admin.email.deliveryRate": "Tasso di consegna",
                "dashboard.admin.email.openRate": "Tasso di apertura",
                "dashboard.admin.email.bounceRate": "frequenza di rimbalzo",
                "dashboard.admin.funnelMetrics": `Metriche dell'imbuto`,
                "dashboard.admin.funnel.registered": "Registrato",
                "dashboard.admin.funnel.confirmed": "Confermato",
                "dashboard.admin.funnel.loggedIn": "Primo accesso",
                "dashboard.admin.funnel.firstMessage": "Primo messaggio",
                "dashboard.admin.funnel.abandoned": "Abbandonato",
                "dashboard.admin.funnel.conversionRate": "Tasso di conversione",
                "dashboard.admin.funnel.activationRate": "Tasso di attivazione",
                "dashboard.admin.funnel.dropoffRate": "Tasso di abbandono",
                "dashboard.admin.loading": "Caricamento metriche...",
                "dashboard.admin.errorLoad": "Impossibile caricare il dashboard delle metriche.",
                "dashboard.admin.growthViral": "Crescita virale",
                "dashboard.admin.growthStable": "Crescita stabile",
                "dashboard.admin.growthLow": "Crescita bassa",
                'upgrade.price.amount': '',
                'upgrade.price.period': '',
                "upgrade.enterprise.title": "ENTERPRISE",
                "errors.modal.code": "Codice",
                "errors.modal.message": "Messaggio",
                "errors.modal.path": "Itinerario",
                "errors.modal.time": "Ora",
                "errors.modal.timestamp": "Timestamp",
                "errors.modal.copied": "Dettaglio copiato",
                "errors.network": "Impossibile connettersi al server. Controlla la tua connessione.",
                "errors.unexpected": "Si è verificato un errore imprevisto. Riprova.",
                "errors.boundary.title": "ERRORE REACT CATTURATO",
                "errors.boundary.request_id": "ID richiesta X:",
                "errors.boundary.correlate": "Mappa su backend/logs/structured.log",
                "errors.boundary.message_label": "Messaggio:",
                "errors.boundary.stack_trace": "Traccia dello stack",
                "errors.boundary.component_stack": "pila di componenti",
                "errors.boundary.empty": "(vuoto)",
                "errors.boundary.reload_page": "Ricarica la pagina",
                "errors.ui_boundary.refresh": `Errore dell'interfaccia ArChat: ricarica della pagina`,
                "bootstrap.error.title": "ArChat®: errore di avvio",
                "common.reload": "Ricaricare",
                "admin.access_denied.message": "Messaggio",
                "admin.access_denied.title": "Titolo",
                "admin.action.change_plan": "Cambia piano",
                "admin.action.reactivate": "Riattivare",
                "admin.action.suspend": "Sospendere",
                "admin.action.view": "Visualizzazione",
                "admin.confirm.change_plan.message": "Messaggio",
                "admin.confirm.change_plan.title": "Titolo",
                "admin.confirm.suspend.message": "Messaggio",
                "admin.confirm.suspend.title": "Titolo",
                "admin.details.created": "Creato",
                "admin.details.current_plan": "Piano attuale",
                "admin.details.domain": "Dominio",
                "admin.details.last_activity": "Ultima attività",
                "admin.details.name": "patata dolce",
                "admin.details.plan": "Piano",
                "admin.details.status": "Stato",
                "admin.details.subscription": "Sottoscrizione",
                "admin.details.tenant_id": "ID inquilino",
                "admin.details.tenant_info": `Informazioni sull'inquilino`,
                "admin.details.usage": "Utilizzo",
                "admin.error.change_plan": "Cambia piano",
                "admin.error.generic": "Generico",
                "admin.error.load_details": "Carica i dettagli",
                "admin.error.load_tenants": "Carica inquilini",
                "admin.error.reactivate": "Riattivare",
                "admin.error.suspend": "Sospendere",
                "admin.error.title": "Titolo",
                "admin.filter.active": "Attivare",
                "admin.filter.all_plans": "Tutti i piani",
                "admin.filter.all_status": "Tutto lo stato",
                "admin.filter.suspended": "Sospendere",
                "admin.limit.devices": "Dispositivi",
                "admin.limit.invitations": "Inviti",
                "admin.limit.messages": "messaggi",
                "admin.limit.storage": "Magazzinaggio",
                "admin.limit.users": "Utenti",
                "admin.loading": "Caricamento",
                "admin.no_tenants": "Non inquilini",
                "admin.plan.enterprise": "Enterprise",
                "admin.plan.free": "Free",
                "admin.plan.pro": "Pro",
                "admin.status.active": "Attivare",
                "admin.status.suspended": "Sospendere",
                'admin.subscription.id': 'Id',
                "admin.subscription.last_payment": "Ultimo pagamento",
                "admin.subscription.status": "Stato",
                "admin.subtitle": "Sottotitolo",
                "admin.success.plan_changed": "Il piano è cambiato",
                "admin.success.tenant_reactivated": "Inquilino riattivato",
                "admin.success.tenant_suspended": "Inquilino sospeso",
                "admin.success.title": "Titolo",
                "admin.table.actions": "Azioni",
                "admin.table.messages": "messaggi",
                "admin.table.name": "patata dolce",
                "admin.table.plan": "Piano",
                "admin.table.status": "Stato",
                "admin.table.storage": "Magazzinaggio",
                "admin.table.tenant_id": "ID inquilino",
                "admin.table.users": "Utenti",
                "admin.title": "Titolo",
                "admin.usage.devices": "Dispositivi",
                "admin.usage.invitations": "Inviti",
                "admin.usage.messages": "messaggi",
                "admin.usage.storage": "Magazzinaggio",
                "admin.usage.users": "Utenti",
                "auth.login": "Login",
                "auth.register": "Registro",
                "auth.reset_password": "reimpostare la password",
                "billing.cancel.button": "pulsante",
                "billing.cancel.canceling": "Annullamento",
                "billing.cancel.confirm": "Confermare",
                "billing.cancel.error": "Errore",
                "billing.cancel.success": "successo",
                "billing.character_billing.characters_used": "Caratteri utilizzati",
                "billing.character_billing.consumption_pct": "Consumo%",
                "billing.character_billing.days_remaining": "Giorni rimasti",
                "billing.character_billing.deletion_date": "Data di cancellazione",
                "billing.character_billing.period_start": "Inizio periodo",
                "billing.character_billing.renewal_date": "Data di rinnovo",
                "billing.character_billing.title": "Titolo",
                "billing.current_plan": "Piano attuale",
                "billing.founder_badge": "Distintivo del fondatore",
                "billing.no_plans": "Non pianificare",
                'billing.subscription.canceled': 'Canceled',
                'billing.subscription.canceled_note': 'Canceled note',
                "billing.subscription.next_payment": "Prossimo pagamento",
                "billing.subscription.plan": "Piano",
                'billing.subscription.price': 'Prezzo del piano',
                "billing.subscription.started": "Iniziato",
                "billing.subscription.status": "Stato",
                "billing.subscription.mp_flow.subscribe_failed": `Impossibile avviare l'abbonamento. Riprova.`,
                "billing.subscription.mp_flow.change_plan_failed": "Il piano non poteva essere cambiato. Riprova.",
                "billing.subscription.mp_status.pending": "Orecchino",
                "billing.subscription.mp_status.authorized": "Autorizzato",
                "billing.subscription.mp_status.active": "Attivo",
                "billing.subscription.mp_status.paused": "In pausa",
                "billing.subscription.mp_status.cancelled": "Annullato",
                "billing.subscription.mp_status.inactive": "Inattivo",
                "billing.subscription.mp_status.unknown": "Uno sconosciuto",
                "billing.unlimited": "Illimitato",
                "billing.update_plan": "Aggiorna piano",
                "billing.update_plan_modal.title": "Titolo",
                "billing.usage.loading": "Caricamento",
                "common.accept": "Accettare",
                "common.confirmPassword": "Conferma password",
                'common.continue': 'Continua',
                "common.error": "Errore",
                "dashboard.upgrade.to_plan": "Pianificare",
                "emoji.noResults": "Nessun risultato",
                "emoji.pick": "Scegliere",
                "export.restricted.message": "Messaggio",
                "export.restricted.title": "Titolo",
                "export.restricted.upgrade": "Aggiornamento",
                "founder.*": "*",
                "help.faq.a1": "A1",
                "help.faq.a2": "A2",
                "help.faq.a3": "A3",
                "help.faq.a4": "A4",
                "help.faq.a5": "A5",
                "help.faq.a6": "A6",
                "help.faq.a7": "A7",
                "help.faq.q1": "Q1",
                "help.faq.q2": "Q2",
                "help.faq.q3": "Q3",
                "help.faq.q4": "Q4",
                "help.faq.q5": "Q5",
                "help.faq.q6": "Q6",
                "help.faq.q7": "D7",
                "help.faq.title": "Titolo",
                "help.howWorks.step4.point7": "Punto7",
                "help.message_time_context.free_vs_pro": "Gratuito contro professionista",
                "help.message_time_context.point5": "Punto5",
                "help.plans.enterprise.benefits": "Vantaggi",
                "help.plans.enterprise.description": "Descrizione",
                "help.plans.enterprise.title": "Titolo",
                "help.plans.foundation.devices": "Dispositivi",
                "help.plans.free.description": "Descrizione",
                "help.plans.free.devices": "Dispositivi",
                "help.plans.free.limits": "Limiti",
                "help.plans.free.title": "Titolo",
                "help.plans.intro": "Introduzione",
                "help.plans.pro.benefits": "Vantaggi",
                "help.plans.pro.description": "Descrizione",
                "help.plans.pro.devices": "Dispositivi",
                'help.plans.pro.price': '$19 / mese',
                "help.plans.pro.title": "Titolo",
                "help.plans.pro.upgrade": "Aggiornamento",
                "help.plans.title": "Titolo",
                "help.plans.urgent_slots_badge": "Badge slot urgenti",
                "help.slogan.final": "FINE",
                "help.suggestions.point1": "Punto1",
                "help.suggestions.point2": "Punto2",
                "help.suggestions.title": "Titolo",
                "invitation.already_contact_added": "Contatto già aggiunto",
                "invitation.already_contact_title": "Titolo già contattato",
                "invitation.already_pending": "Già in sospeso",
                "invitation.language.invalid": "Non valido",
                "message.send": "Inviare",
                "message.sendFile": "InviaFile",
                "messages.conversations": "Conversazioni",
                "messages.no_conversations_subtitle": "Nessun sottotitolo delle conversazioni",
                "messages.no_conversations_title": "Nessun titolo delle conversazioni",
                "presence.custom.edit": "Modificare",
                "profile.enrichment.country": "Paese",
                "profile.enrichment.country.select": "Selezionare",
                "profile.enrichment.description": "Descrizione",
                "profile.enrichment.org_size": `Dimensioni dell'organizzazione`,
                "profile.enrichment.org_size.placeholder": "segnaposto",
                "profile.enrichment.save": "Salva",
                "profile.enrichment.skip": "saltare",
                "profile.enrichment.title": "Titolo",
                "profile.enrichment.usage_type.label": "Etichetta",
                "profile.enrichment.usage_type.placeholder": "segnaposto",
                "profile.founderPosition": "Posizione del fondatore",
                "settings.confirmations.description": "Descrizione",
                "settings.confirmations.disable": "Disabilita",
                "settings.confirmations.title": "Titolo",
                "settings.confirmations.updated": "Aggiornato",
                "settings.title": "Titolo",
                "theme.description": "Descrizione",
                "google.unavailable_tenant": "Google non è disponibile per questo tenant.",
                "google.unavailable": "Google non disponibile.",
                "google.verify_client_id": `Verifica l'ID cliente in Google Cloud Console.`,
                'google.login_aria': 'Accedi con Google',
                "message.preview_alt": "Anteprima",
                "message.image_attachment_alt": "Immagine allegata",
                "profile.avatar.alt": "avatar",
                "plan.name.free": "FREE",
                "plan.name.pro": "PRO",
                "plan.name.foundation": "FOUNDATION",
                "plan.name.enterprise": "ENTERPRISE",
                "register.emailPlaceholder": "you@email.com",
                "invitation.top.loading": "Caricamento dei principali invitanti...",
                "invitation.top.empty": "Nessun invitato ancora presente.",
                "invitation.contacts.title": "Invita contatti",
                "invitation.contacts.safe_phase_note": "Fase sicura attiva: benefici pendenti senza impatto sui limiti reali.",
                "invitation.contacts.generate_code": "Genera codice/link",
                "invitation.contacts.refresh_top3": "Aggiorna i primi 3",
                "invitation.contacts.hide_full_ranking": "Nascondi la classifica completa",
                "invitation.contacts.show_full_ranking": "Mostra la classifica completa",
                "invitation.contacts.hide_metrics_dashboard": "Nascondi dashboard delle metriche",
                "invitation.contacts.show_metrics_dashboard": "Mostra dashboard delle metriche",
                "invitation.contacts.prepared_link_label": "Collegamento preparato:",
                "invitation.contacts.email_placeholder": "e-mail@dominio.com",
                "invitation.contacts.register_pending": "Registrati in attesa di invito",
                "invitation.contacts.status_summary": "Riepilogo dello stato",
                "invitation.contacts.sent_invitations": "Inviti inviati",
                "invitation.contacts.invited_email": "E-mail invitata",
                "invitation.contacts.code": "codice",
                "invitation.contacts.no_sent_invitations": "Non ho ancora inviato gli inviti.",
                "invitation.contacts.simulated_rewards": "Premi simulati ottenuti",
                "invitation.contacts.no_simulated_rewards": "Nessun premio simulato ancora.",
                "common.id": "ID",
                "common.created": "Creato",
                'plan.pro_contacts': 'Fino a 100 contatti per utente',
                "common.status": "Stato",
                "login.prompt_create_account_with_name": "Vuoi creare un account con questo nome?",
                'plans.upgrade.title': 'Aggiorna piano',
                'plans.upgrade.comparison': 'Confronto piani',
                'plans.upgrade.billing': '',
                'plans.upgrade.cancel_anytime': 'Annulla quando vuoi',
                'plans.actions.upgrade_pro': 'Passa a PRO',
                'plans.actions.become_founder': 'Diventa Founder',

                'plans.modal.card.current_badge': 'Il tuo piano attuale',

                'plans.modal.card.lower_tier': 'Sotto il tuo piano attivo',

                'plans.modal.card.manage_in_profile': 'Per modificare o annullare: Abbonamento e fatturazione nel profilo.',
                'plans.modal.card.cancel_subscription': 'Annulla abbonamento',
                'plans.modal.cancel_confirm.title': 'Annulla o gestisci abbonamento',
                'plans.modal.cancel_confirm.body': 'Si aprirà una nuova scheda con il portale sicuro Paddle per aggiornare pagamento, fatture o annullare l’abbonamento.',
                'plans.modal.cancel_confirm.continue_button': 'Continua',
                'plans.modal.cancel_confirm.back_button': 'Indietro',
                'plans.modal.cancel_paddle_fallback.title': 'Gestisci l’abbonamento',
                'plans.modal.cancel_paddle_fallback.body': 'Il portale di fatturazione Paddle non si apre in questo ambiente (es. sviluppo locale o account non ancora collegato). Puoi comunque consultare e confrontare i piani qui.',
                'plans.modal.cancel_paddle_fallback.confirm': 'OK',
                'plans.upgrade_required': 'Disponibile nel piano PRO',
                'settings.heading': 'Impostazioni',
                'settings.dashboard': 'Cruscotto',
                'settings.dashboardDescription': 'Preferenze locali per il pannello iniziale e i blocchi visibili.',
                'settings.dashboardGridHeading': 'Blocchi del pannello',
                'settings.dashboardShowOnStartDescription': 'Se attivo, il cruscotto si apre all’accesso al posto dell’elenco contatti.',
                'settings.dashboardBlockWelcome': 'Benvenuto',
                'settings.dashboardBlockUsage': 'Uso piano',
                'settings.dashboardBlockFiles': 'I miei file',
                'settings.dashboardBlockPromotions': 'Promozioni',
                'settings.dashboardBlockSessions': 'Sessioni',
                'settings.dashboardWelcomeDescription': 'Primi passi, invito contatto e scorciatoie di aiuto.',
                'settings.dashboardUsageDescription': 'Uso rispetto ai limiti: contatti, caratteri, spazio, dispositivi.',
                'settings.dashboardFilesDescription': 'Riepilogo file visibili e spazio in I miei file.',
                'settings.dashboardPromotionsDescription': 'Riepilogo promozioni e collegamento al programma.',
                'settings.dashboardSessionsDescription': 'Sessioni e dispositivi attivi; chiusura altre sessioni se disponibile.',
                'settings.enabled': 'Attivo',
                'settings.disabled': 'Disattivato',
                'settings.showDashboardOnStart': 'Mostra il cruscotto all’accesso',
                'settings.showWelcomeBlock': 'Mostra il blocco di benvenuto',
                'settings.showPromotionsBlock': 'Mostra il blocco promozioni',
                'settings.showUsageBlock': 'Mostra l’utilizzo del piano',
                'settings.showRecentConversationsBlock': 'Mostra conversazioni recenti (ultimo messaggio per contatto)',
                'settings.showSessionsBlock': 'Mostra le sessioni attive',
                'settings.showFilesBlock': 'Mostra il riepilogo file',
                'settings.dashboardLocalNote': 'Le preferenze restano in questo browser (locali) fino a un’API profilo.',
                'settings.appearanceSettings': 'Aspetto',
                "settings.argentinaTheme": `Tema dell'Argentina`,
                'settings.darkMode': 'Modalità scura',
                'settings.language': 'Lingua',
                'settings.messageSound': 'Suono messaggi',
                'settings.playSoundDescription': 'Riproduci un suono per nuovi messaggi o avvisi importanti.',
                'settings.messageSoundEnabled': 'Attivo',
                'settings.messageSoundDisabled': 'Disattivo',
                "settings.accountSettings": "Account",
                'settings.deleteAccount': 'Elimina account',
                'settings.deleteAccountWarning': 'Questa azione è permanente. I tuoi dati, messaggi, contatti e impostazioni saranno rimossi secondo il processo di eliminazione della piattaforma.',
                'settings.deleteMyAccount': 'Elimina il mio account',
                'dashboard.contacts': 'Contatti',
                'dashboard.characters': 'Caratteri',
                'dashboard.storage': 'Archiviazione',
                'dashboard.active_devices': 'Dispositivi attivi',
                'dashboard.need_more_resources': 'Hai bisogno di più risorse?',
                'dashboard.upgrade_message': 'Aggiorna il tuo piano per ottenere più contatti, caratteri, spazio di archiviazione e dispositivi attivi.',
                'dashboard.upgrade_button': 'Passa a PRO',
                'dashboard.upgrade_button_pro': 'Passa a PRO',
                'dashboard.upgrade_button_foundation': 'Passa a FOUNDATION',
                'files.preview': 'Anteprima',
                'files.previewFile': 'Anteprima file',
                'files.previewUnavailable': "Anteprima non disponibile.",
                'files.previewLoading': "Caricamento anteprima…",
                'files.openPreview': 'Anteprima',
                'files.downloadFile': 'Scarica file',
                'files.downloadFailed': 'Impossibile scaricare il file. Controlla connessione e sessione, poi riprova.',
                'files.closePreview': "Chiudi anteprima",
                'files.unsupportedPreview': "Nessuna anteprima per questo tipo di file. Puoi consultare i dettagli o scaricare.",
                'files.pdfPreviewHelp': "Il browser potrebbe non mostrare il PDF incorporato. Usa Scarica per aprirlo.",
                "files.labelFileType": "Tipo",
                'files.previewForbidden': "Non hai permesso per l'anteprima.",
                'files.previewNotFound': "File non disponibile o non più visibile.",
                'files.unavailableForFree': 'I miei file non è incluso nel piano FREE.',
                'files.availableInFoundationAndPro': 'I miei file è disponibile con FOUNDATION e PRO.',
                'files.filesFeatureRestricted': 'Questa funzione non è disponibile con il tuo piano attuale.',
                'files.filesLoadError': 'Errore nel caricamento dei file.',
                'files.uploadUnavailableForFree': "L'invio di file non è disponibile nel piano FREE.",
                'files.uploadAvailableInFoundationAndPro': "L'invio di file è disponibile con FOUNDATION e PRO.",
                'files.recipientStorageFull': 'Il destinatario non ha spazio disponibile per ricevere questo file.',
                'files.recipientNoAvailableStorage': 'Il destinatario non ha spazio disponibile per ricevere questo file.',
                'files.storageQuotaExceeded': 'Hai raggiunto il limite di archiviazione del tuo piano.',
                'files.freeStorageLimit': 'Il piano FREE include 5 MB di spazio per i file ricevuti.',
                'settings.unreadEmailReminderSection': 'Riepilogo e-mail non letti',
                'settings.unreadEmailReminderDescription': 'Se lasci nuovi messaggi o file non letti oltre l’attesa indicata sotto, ArChat invia un’unica e-mail di riepilogo (non una per messaggio).',
                'settings.unreadEmailReminderToggle': 'Inviami riepiloghi via e-mail',
                'settings.unreadEmailDelayHours': 'Attesa prima dell’invio (ore)',
                'settings.unreadEmailDelayHint': '1–168 ore (fino a una settimana). L’e-mail usa la lingua del profilo.',
                'subjects.title': 'Argomenti',
                'subjects.singular': 'Argomento',
                'subjects.plural': 'Argomenti',
                'subjects.general': 'Generale',
                'subjects.new': 'Nuovo argomento',
                'subjects.create': 'Crea argomento',
                'subjects.rename': 'Rinomina',
                'subjects.finish': 'Concludi',
                'subjects.reopen': 'Riapri',
                'subjects.select': 'Continua',
                'subjects.status.open': 'Aperto',
                'subjects.status.pending': 'In sospeso',
                'subjects.status.finished': 'Concluso',
                'subjects.limitReached': 'Hai raggiunto il limite di argomenti attivi in questa conversazione. Concludi un argomento per crearne un altro.',
                'subjects.limitReachedFree': 'Il piano FREE consente fino a 3 argomenti attivi per conversazione. Concludi un argomento per crearne un altro.',
                'subjects.limitReachedPro': 'Il piano PRO consente fino a 5 argomenti attivi per conversazione. Concludi un argomento per crearne un altro.',
                'subjects.limitReachedFoundation': 'Il piano FOUNDATION consente fino a 5 argomenti attivi per conversazione. Concludi un argomento per crearne un altro.',
                'subjects.activeLimitsLine': 'Argomenti attivi: {current} / {max}',
                'subjects.closedListTitle': 'Argomenti chiusi',
                'subjects.viewClosed': 'Visualizza argomenti chiusi',
                'subjects.noClosedSubjects': 'Non ci sono argomenti chiusi.',
                'subjects.reopenSubject': 'Riapri',
                'subjects.reopenedSubjects': 'Argomenti riaperti',
                "subjects.reopenLimitReached": `topics.ownerOnlyReopen': 'Solo la persona che ha creato l'oggetto può riaprirlo.`,
                'subjects.ownerOnlyReopen': 'Solo chi ha creato questo argomento può riaprirlo.',
                'subjects.modal.title': 'Argomenti della conversazione',
                'subjects.modal.subtitle': 'Scegli o gestisci gli argomenti di questa conversazione.',
                'subjects.contactLabel': 'CONTATTO:',
                'subjects.ownerOnlyRename': 'Solo chi ha creato l’argomento può cambiarne il nome.',
                'subjects.ownerOnlyStateChange': 'Solo chi ha creato l’argomento può cambiarne lo stato.',
                'subjects.createdByOther': 'Questo argomento è stato creato dall’altra parte. Puoi rispondere, ma non rinominarlo.',
                'subjects.empty': 'Nessun argomento da mostrare.',
                'subjects.noResults': 'Nessun argomento trovato.',
                'subjects.error.generic': 'Impossibile completare l’azione. Riprova.',
                'subjects.error.featureDisabled': 'Gli argomenti non sono disponibili in questo ambiente.',
                'subjects.error.duplicateName': 'Esiste già un argomento attivo con questo nome.',
                'subjects.error.ownerRequired': 'Non hai il permesso di modificare questo argomento.',
                'subjects.error.defaultCannotRename': 'L’argomento Generale non può essere rinominato.',
                'subjects.error.defaultCannotFinish': 'L’argomento Generale non può essere concluso.',
                'subjects.current': 'Argomento',
                'subjects.change': 'Cambia argomento',
                'subjects.currentLabel': 'Argomento:',
                'subjects.changeSubject': 'Cambia argomento',
                'subjects.closedCannotSend': 'Questo argomento è concluso. Riaprilo per inviare nuovi messaggi.',
                'subjects.selectBeforeSend': 'Scegli un argomento nella finestra per vedere i messaggi e inviare.',
                'subjects.loadingMessages': 'Caricamento messaggi per questo argomento…',
                'subjects.messageFilterError': 'Impossibile caricare i messaggi per questo argomento.',

                // Tags
                "tags.etiquetas": "tag",
                "tags.manageTitle": "Gestisci i tag",
                "tags.manage": "🏷️ Tag",
                "tags.allTags": "Tutti i tag",
                "tags.confirmDelete": "Eliminare questo tag?",
                "tags.tagNamePlaceholder": "Nome dell'etichetta",
                "tags.create": "Creare",
                "tags.noTags": "Nessun tag. Creane uno sopra.",
                "tags.save": "Salva",
                "tags.edit": "Modificare",
                "tags.delete": "Eliminare",
                "tags.assignTo": "Assegna a",
                "tags.noTagsToAssign": "Nessun tag disponibile. Creali prima.",
                // Templates
                "templates.selectTitle": "Modelli",
                "templates.noTemplates": "Nessun modello. Creane uno sopra.",
                "templates.manage": "Gestisci modelli",
                "templates.confirmDelete": "Eliminare questo modello?",
                "templates.manageTitle": "Gestisci modelli",
                "templates.titlePlaceholder": "Titolo del modello",
                "templates.bodyPlaceholder": "Scrivi il modello di messaggio...",
                "templates.create": "Crea modello",
                "templates.save": "Salva",
                "templates.edit": "Modificare",
                "templates.delete": "Eliminare",
                // Tags (added)
                "tags.bgColor": "Colore di sfondo",
                "tags.textColor": "Colore del testo",
                "tags.selectTag": "Seleziona un'etichetta",
                // Web Push notifications
                "settings.webPushSection": "Notifiche di sistema (Web Push/PWA)",
                "settings.webPushDescription": "Consente avvisi quando l'app è in background o chiusa sul dispositivo mobile. Richiede la chiave pubblica VAPID nella build (VITE_VAPID_PUBLIC_KEY) e le chiavi del server. Concede l'autorizzazione del browser e registra questo dispositivo.",
                "settings.webPushButton": "Abilita le notifiche push",
                "settings.webPushRegistering": "Registrazione…",
                "settings.webPushState.granted": "Autorizzazione concessa. Se VAPID è configurato, la sottoscrizione è stata inviata al server.",
                "settings.webPushState.denied": "Autorizzazione negata. Abilita le notifiche per questo sito nelle impostazioni del browser.",
                "settings.webPushState.default": "Tocca il pulsante per richiedere l'autorizzazione e registrare questo dispositivo.",
                "settings.webPushState.unsupported": "Questo browser non supporta Web Push.",
                "settings.webPushVapidMissing": "VITE_VAPID_PUBLIC_KEY manca in questa build frontend: impossibile completare la sottoscrizione push.",
                ...PRESET_LOCALES.it,
                "auth.login.clear_password_lock_after_reset": "Ho già cambiato la mia password (ad esempio su un altro dispositivo)",
                "auth.signup_disabled": "La registrazione di un nuovo account è temporaneamente disabilitata in questo ambiente.",
                "auth.reset_user_not_found": "Non abbiamo trovato un account associato a quell'e-mail. Controlla che sia scritto correttamente o crea un nuovo account.",
                "account.not_found": "Conto non trovato.",
                "auth.pending_activation.title": "Conto in attesa di attivazione",
                "auth.pending_activation.body": "Il tuo account non è ancora attivato. Controlla la tua email e conferma la registrazione per accedere ad ArChat.",
                "auth.pending_activation.back_to_login": "Torna al login",
                "auth.pending_activation.support_prefix": "Hai bisogno di aiuto? Contatta l'assistenza:",
                "auth.pending_activation.support_email": "info@archat.com.ar",
                "auth.pending_activation.email_label": "E-mail per inviare nuovamente l'attivazione",
                "auth.pending_activation.email_placeholder": "tu@email.com",
                "auth.pending_activation.email_required": "Inserisci l'email con cui ti sei registrato per inviare nuovamente l'attivazione.",
                "auth.pending_activation.sent_title": "E-mail di attivazione inviata",
                "auth.pending_activation.sent_body": "Se l'email corrisponde ad un account in sospeso, ti invieremo un nuovo link di attivazione. Controlla la tua casella di posta e anche lo spam o la posta indesiderata.",
                "auth.pending_activation.soft_error_title": "Nuovo invio non disponibile",
                "auth.pending_activation.soft_error_body": "Al momento non è stato possibile elaborare il nuovo invio. Riprova tra qualche minuto o scrivici a info@archat.com.ar.",
                "auth.pending_activation.resend_again": "Invia nuovamente",
                "menu.plans": "Piani",
                "files.title": "i miei file",
                "files.filter_all": "Tutto",
                "files.filter_sent": "Inviato",
                "files.filter_received": "Ricevuto",
                "files.filter_images": "Immagini",
                "files.filter_documents": "Documenti",
                "files.col_name": "Nome",
                "files.col_size": "Misurare",
                "files.col_date": "Data",
                "files.col_direction": "Dir.",
                "files.col_actions": "Azioni",
                "files.sent": "📤 Inviato",
                "files.received": "📥Ricevuto",
                "files.download": "Scarico",
                "files.delete_for_me": "Cancella per me",
                "files.delete_confirm_title": "Elimina file",
                "files.delete_confirm_message": "Questo file verrà eliminato dal tuo account. Non verrà eliminato per l'altra persona. Continuare?",
                "files.empty": "Non hai file.",
                "files.error_loading": "Errore durante il caricamento dei file.",
                "files.load_more": "Carica di più",
                "message.status.sending": "Invio…",
                "message.status.failed": "Non inviato",
                "message.status.sent": "Inviato",
                "message.status.delivered": "Consegnato",
                "message.status.read": "Leggere",
                "home.public_nav.pricing": "Prezzi",
                "home.public_nav.aria": "Navigazione principale del sito",
                "home.public_footer.aria": "Collegamenti legali",
                "home.pricing_link": "Piani e prezzi",
                "publicPricing.nav.back_home": "← Casa",
                "publicPricing.title": "Piani e prezzi",
                "publicPricing.subtitle": "Limiti trasparenti e allineati al motore di abbonamento ArChat. Prezzi commerciali in USD per pagamenti internazionali (ad es. Paddle).",
                "publicPricing.commercial_note": "I confini funzionali provengono da PlanConstants/PlanResolver; il tuo account può applicare plan_limits nel database. L'addebito al commerciante utilizza Paddle (o altri processori ufficialmente designati da ArChat) con prezzi in USD come indicato.",
                "publicPricing.plan.free": "FREE",
                "publicPricing.plan.foundation": "FOUNDATION",
                "publicPricing.plan.pro": "PRO",
                "publicPricing.price.free": "USD 0 / mes",
                "publicPricing.price.foundation": "USD {price} / mes",
                "publicPricing.price.pro": "USD {price} / mes",
                "publicPricing.same_limits_pro": "Stessi limiti tecnici di PRO (contratto premium).",
                "publicPricing.same_limits_foundation": "Stessi limiti tecnici della FOUNDATION (contratto premium).",
                "publicPricing.badge.foundation": "Programa Founder",
                "publicPricing.badge.pro": "Recomendado",
                "publicPricing.free.b1": "30.000 caratteri al mese per account.",
                "publicPricing.free.b2": "Fino a 2 contatti per utente; fino a 2 conversazioni attive per account.",
                "publicPricing.free.b3": "Nessun allegato o spazio di archiviazione; senza esportazione dei dati.",
                "publicPricing.free.b4": "Cronologia dei messaggi fino a 30 giorni; 1 dispositivo per utente.",
                "publicPricing.free.b5": "34 messaggi/giorno e 1.000 messaggi/mese (tenant); fino a 20 inviti al giorno.",
                "publicPricing.premium.b1": "300.000 caratteri al mese per account; fino a 100 contatti per utente.",
                "publicPricing.premium.b2": "Conversazioni e chat illimitate (tenant); 1.667 messaggi/giorno e 50.000/mese.",
                "publicPricing.premium.b3": "Fino a 50 MB di spazio di archiviazione (tenant); fino a 3 dispositivi per utente.",
                "publicPricing.premium.b4": "Inviti illimitati (tenant); esportazione, traduzione automatica e file secondo il piano.",
                "publicPricing.premium.b5": "FOUNDATION: stesso contratto tecnico del PRO, più programma Founder (150 posti). PRO: standard premium.",
                "publicPricing.foundation.founder_note": "Programma commerciale Founder: numero limitato di {slots} posti (vedi riepilogo del piano). Stessi limiti PRO una volta attivato l'abbonamento.",
                "publicPricing.cta.start_free": "Crea un account gratuito",
                "publicPricing.cta.register_paid": "Creare un account",
                "publicPricing.paddle_hint": "Il pagamento con il processore scelto verrà completato all'interno dell'applicazione quando la ricarica è abilitata.",
                "publicPricing.legal.nav_label": "Legale",
                "publicPricing.legal.terms": "Termini di servizio",
                "publicPricing.legal.privacy": "politica sulla riservatezza",
                "publicPricing.legal.refund": "Politica di rimborso",
                "profile.security.privacy_note": "Gestisci la privacy e la sicurezza del tuo account.",
                "profile.security.sessions_title": "Sessioni attive",
                "profile.security.current": "Sessione corrente",
                "profile.plan.foundation.description": "Piano FOUNDATION (Founder): stessa fruizione premium del PRO, con programma Founder e posti limitati (150 posti).",
                "billing.view_plans": "Vedi i piani",
                "billing.paddle.cancel_via_portal": "Annulla l'abbonamento",
                "billing.paddle.test_access_denied_body": "Su questo server le operazioni di fatturazione sono limitate (modalità test o lista test). Se hai già pagato con un conto reale, in produzione il pagamento deve essere consentito a tutti gli utenti (ad esempio PAYMENT_ALLOW_ALL_BILLING_USERS) oppure tale restrizione deve essere disabilitata. Contatta l'assistenza.",
                "attachment.storage_insufficient_precheck.title": "Spazio insufficiente",
                "attachment.storage_insufficient_precheck.message": "Il file pesa {fileSizeMb} MB e hai solo {availableMb} MB disponibili. Libera spazio o migliora il tuo piano per continuare.",
                "attachment.files_disabled.title": "Limite del piano",
                "attachment.files_disabled.message": "Il tuo piano attuale non include l'invio di file. Migliora il tuo piano per continuare.",
                "contacts.viewContactInfo": "Visualizza i dettagli di contatto",
                "contacts.contactInfoTitle": "Dettagli di contatto",
                "contacts.phone": "Telefono",
                "contacts.bio": "Biografia",
                "contacts.notProvided": "Disinformato",
                "contacts.unread.badge": "Messaggi non letti",
                "dashboard.recentInbound.title": "Ultimi messaggi ricevuti",
                "dashboard.recentInbound.empty": "Non hai ricevuto messaggi recenti.",
                "dashboard.recentInbound.error": "Impossibile caricare i messaggi.",
                "dashboard.recentInbound.previewPhoto": "Foto",
                "dashboard.recentInbound.previewFile": "Archivio",
                "dashboard.recentInbound.previewPdf": "PDF",
                "dashboard.recentInbound.previewUnavailable": "Messaggio non disponibile",
                "dashboard.recentInbound.readTitle": "Leggere",
                "dashboard.recentInbound.unreadTitle": "non letto",
                "dashboard.recentConversations.title": "Conversazioni recenti",
                "dashboard.recentConversations.empty": "Non ci sono conversazioni da mostrare.",
                "dashboard.recentConversations.error": "Impossibile caricare le conversazioni.",
                "dashboard.plan.foundation": "FOUNDATION",
                "plan.errors.translationNotAllowed.title": "Traduzione non disponibile",
                "plan.errors.translationNotAllowed.message": "Il tuo piano attuale non include la traduzione automatica tra le lingue.",
                "plan.errors.translationNotAllowed.solution": "Per utilizzare la traduzione automatica, aggiorna il tuo piano.",
                "billing.subscription.cancel_scheduled_date": "L'annullamento del tuo abbonamento è previsto per il {{date}}. Puoi continuare a utilizzare il tuo piano fino ad allora.",
                "billing.subscription.cancel_scheduled_badge": "Annullato il {{date}}",
                "billing.scheduled.plan_after_cancel_label": "Piano alla fine del periodo:",
                "billing.scheduled.plan_free": "FREE (gratuito)",
                "billing.scheduled.plan_foundation": "FOUNDATION",
                "billing.scheduled.switch_to_foundation": "Passare a FONDAZIONE",
                "billing.scheduled.switch_to_free": "Cambia in GRATUITO",
                "billing.scheduled.foundation_full_title": "FONDAZIONE non disponibile",
                "billing.scheduled.foundation_full_message": "Non ci sono posti FOUNDATION disponibili in questo momento. Il tuo piano passerà a GRATUITO alla fine del periodo.",
                "billing.scheduled.saving": "Risparmio...",
                "billing.scheduled.error_title": "Errore durante il cambio del piano",
                "billing.scheduled.error_generic": "Non è stato possibile modificare il piano pianificato. Riprova.",
                "billing.cancel_scheduled.title": "Cancellazione programmata",
                "billing.cancel_scheduled.desc": "Il tuo abbonamento verrà annullato il {{date}}. Fino ad allora puoi continuare a utilizzare il tuo piano attuale.",
                "billing.cancel_scheduled.no_new_plan_until_end": "Fino alla scadenza dell'abbonamento non potrai stipulare un altro piano.",
                "billing.cancel_scheduled.free_fallback": "Se non rinnovi nessun piano, il tuo account continuerà GRATIS con le relative limitazioni.",
                "billing.cancel_scheduled.profile_deactivation_hint": "Puoi anche annullare l'iscrizione alla piattaforma dal tuo profilo.",
                "billing.cancel_scheduled.default_free": "Alla fine del periodo: GRATUITO",
                "google.missing_client_id": "L'accesso con Google non è disponibile in questa build: VITE_GOOGLE_CLIENT_ID (o googleClientId per tenant in __ARCHAT_TENANT_CONFIG__) manca.",
                "reviews.title": "Recensioni di ArChat",
                "reviews.create_title": "Come valuteresti ArChat?",
                "reviews.edit_title": "Modifica la mia recensione",
                "reviews.comment_placeholder": "Raccontaci la tua esperienza (facoltativo)...",
                "reviews.submit_btn": "Invia recensione",
                "reviews.update_btn": "Aggiornamento",
                "reviews.thank_you": "Grazie per la tua recensione!",
                "reviews.submitted_message": "La tua opinione ci aiuta a migliorare.",
                "reviews.error_select_rating": "Seleziona una valutazione",
                "reviews.error_generic": "Errore durante l'invio della recensione",
                "reviews.prompt_message": "Ti piace ArChat? Lascia la tua recensione!",
                "reviews.rate_now": "Qualificare",
                "reviews.later": "Dopo",
                "reviews.write_review": "Scrivi recensione",
                "reviews.edit_my_review": "Modifica la mia recensione",
                "reviews.no_reviews": "Non ci sono ancora recensioni Sii il primo!",
                "reviews.review_singular": "revisione",
                "reviews.review_plural": "recensioni",
                "reviews.verified": "Verificato",
                "reviews.anonymous": "Anonimo",
                "files.storageUsed": "Spazio utilizzato",
                "files.planQuota": "Quota del piano",
                "files.availableStorage": "Disponibile",
                "files.usagePercent": "usato",
                "files.unlimited": "Illimitato",
                "files.sentBy": "Inviato da",
                "files.unknownUser": "Utente",
};


